import { Component, ViewChild, OnInit, NgZone } from '@angular/core';
import cytoscape from 'cytoscape';

import dblclick from 'cytoscape-dblclick';
cytoscape.use(dblclick);

import contextMenus from 'cytoscape-context-menus';
cytoscape.use(contextMenus);
import { DataStorageService } from './shared/servizi/data-storage.service';
import { debounceTime, distinctUntilChanged, filter, map, pairwise, take, throttleTime } from 'rxjs/operators';
import popper from 'cytoscape-popper';
import { forkJoin, Subject, Subscription } from 'rxjs';
import { DbClicService } from './shared/servizi/posizioni/posizioni_db-clic.service';
import { CtxmenuComponent } from './shared/ctxmenu/ctxmenu.component';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { FormControl, FormGroup } from '@angular/forms';
import { HeaderComponent } from './header/header.component';
import { SpinnerService } from './shared/servizi/spinner/spinner.service';
import { DistanzaIponimiaComponent } from './distanza_relazioni/distanza-iponimia/distanza-iponimia.component';
import { DistanzaMeronimiaComponent } from './distanza_relazioni/distanza-meronimia/distanza-meronimia.component';
import { LayoutMenuComponent } from './layout-menu/layout-menu.component';
import { NewElementsComponent } from './creaElementi/new-elements/new-elements.component';
cytoscape.use(popper);
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css', './mediaquerie.css']
})
export class AppComponent implements OnInit {
  sub1: Subscription;
  sub2: Subscription;
  sub3: Subscription

  constructor(
    private dataStorageService: DataStorageService,
    private posizioni_dbClic: DbClicService,
    private ngZone: NgZone,
    private spinner: SpinnerService) { }

  @ViewChild(CtxmenuComponent, { static: true }) istanzaCtxMenu: CtxmenuComponent;
  @ViewChild(CdkVirtualScrollViewport) scroller: CdkVirtualScrollViewport;
  @ViewChild(HeaderComponent, { static: true }) istanzaHeaderC: HeaderComponent;
  @ViewChild(DistanzaIponimiaComponent, { static: true }) istanzaDistanzaIpo: DistanzaIponimiaComponent;
  @ViewChild(DistanzaMeronimiaComponent, { static: true }) istanzaDistanzaMero: DistanzaMeronimiaComponent
  @ViewChild(LayoutMenuComponent, { static: true }) istanzaLayoutMenu: LayoutMenuComponent;
  @ViewChild(NewElementsComponent, { static: true }) NewElementsComponent: NewElementsComponent;

  title = 'DemoLexiconGraph';
  cy: any;
  contextMenu; //variabile context menu
  nodiSelezionati: any[] = [];
  currentEle: string;
  zoomCurrent: number = 1;

  clicked: boolean = false;
  focusNode: string;
  relationType: string;
  relDistanza1: string;
  relDistanza2: string;
  lenght: number;
  arrayNodi: any[] = [];
  arrayNodi2livello: any[] = [];
  arrayEdge: any[] = [];
  arrayEdge2livello: any[] = [];
  // STATO IPONIMIA
  statoNodiIpo: any[];
  statoEdgeIpo: any[];
  ipoDisable: boolean;
  // STATO MERONIMIA
  statoNodiMero: any[];
  statoEdgeMero: any[];
  // STATO SINONIMIA
  statoNodiSino: any[];
  statoEdgeSino: any[];

  clicks = 0;
  timer = null;
  layoutSinonimi;

  // array elementi relazioni semantiche
  arrayIponimia: any[] = [];
  arrayMeronimia: any[] = [];
  arraySinonimia: any[] = [];

  // colonna sinistra filtro e virtual scroll
  searchText = '';
  searchMode = "startsWith";
  type = "word";
  field = "";
  pos = "";
  formType = "entry";
  author = "";
  lang = "it";
  status = "";
  offset = 0;
  limit = 200;
  totalCount;
  sensi: any[];
  sensiVisibili: any[];

  cercaSenso: FormGroup;
  tip;

  disabFormIpo;
  // valori form distanza da inviare tramite ctx mwnu
  valoreIpo: number;
  valoreIpe: number;
  valoreMero: number;
  valoreOlo: number;
  // relazione iponimia
  disabIpo: boolean;
  disabIpe: boolean;
  // relazione meronimia
  disabMero: boolean;
  disabOlo: boolean;

  // resetto valore tutte relazioni
  visualizzaRelazioni;
  statoTutteRelazioni: any[];
  arrayTutteRelazioni: any[] = [];
  valoreFormTutteRel: number;
  layoutCise: boolean;
  layoutCoseBilkent: boolean;
  layoutCola: boolean;
  layoutEuler: boolean;
  layoutCose: boolean;

  checkboxIpoRicev: boolean;
  checkboxMeroRicev: boolean;
  checkboxSinoRicev: boolean;

  // variabili per stoppare form distanza rel ipo
  stopIpo: boolean;
  stopIpe: boolean;

  // variabili per stoppare form distanza rel mero
  stopMero: boolean;
  stopOlo: boolean;
  // variabile per aggiungere class label a header
  isChecked: boolean;

  // variabili boolean per nascondere o mostra form distanza ipo o mero
  showFormIpo: boolean = false;
  showFormMero: boolean = false;
  showFormSino: boolean = false;

  // valore max per input distanza
  valoreMaxIpo: number;
  valoreMaxIpe: number;

  // variabili componente filtro multiplo
  filtroMultiploCheck: boolean = false;
  showComponent: boolean = false;
  showComponentSingle: boolean = true;
  // variabili per rimuovere e restore nodi al passaggio tra una view e l'altra
  viewSingola: any;
  viewMultipla: any;
  viewMultiplaRicevuta: any;

  navigazioneScelta: string;
  // navigazione multipla
  clickMultiplo: boolean = true;
  nodiSelezionatiMultiploLength: number;
  eventsSubject: Subject<string> = new Subject();
  isOpen: boolean = false;
  pageIsRefresh: boolean;
  eventsSubjectPageRefresh: Subject<any> = new Subject();
  disabilitaSliderBtn: boolean;
  isCheck: boolean;
  conceptIncludesIsCheck: boolean;
  // btn min path clicked
  eventsSubjectBtnMinPathClicked: Subject<any> = new Subject();
  // recupero inferenze
  eventsSubjectInferenzeRecuperate: Subject<any> = new Subject();
  // recupero concetti
  eventsSubjectConcettiRecuperati: Subject<any> = new Subject();
  // info nodi ricevute da new ele component
  idRicevuto: string;
  labelRicevuto: string;
  definitionRicevuto: string;

  ngOnInit() {
    this.navigazioneScelta = 'navigazione'
    const that = this; //toglie errore undefined
    that.istanzaHeaderC.relazioneMeronimiaDistanza = new FormGroup({
      meronimo: new FormControl(),
      olonimo: new FormControl()
    });
    that.istanzaHeaderC.relazioneIponimiaDistanza = new FormGroup({
      iperonimo: new FormControl(),
      iponimo: new FormControl()
    });
    that.istanzaHeaderC.tutteRelazioni = new FormGroup({
      relazioni: new FormControl()
    });

    this.fetchSenses();
    this.cercaSenso = new FormGroup({
      cercaUnSenso: new FormControl()
    });

    this.cercaSenso.get('cercaUnSenso').valueChanges.pipe(
      debounceTime(500)
      , distinctUntilChanged()
    ).subscribe((text: string) => {
      this.dataStorageService.fetchLexicalSense(text.toLowerCase(), this.searchMode, this.type,
        this.field, this.pos, this.formType, this.author, this.lang, this.status, this.offset, this.limit).pipe(take(1)).subscribe(lexicalEntry => {
          this.sensi = lexicalEntry.list.filter(t =>
            t.senseInstanceName !== '' && t.definition !== ''
          );
          this.sensiVisibili = lexicalEntry.list;
        });
    });
    this.cy = cytoscape({
      container: document.getElementById('cy'),
      minZoom: 0.2,
      maxZoom: 5.0,
      zoomingEnabled: true,
      zoom: this.zoomCurrent,
      textureOnViewport: true,
      hideEdgesOnViewport: true,
      wheelSensitivity: 0.1,

      style: [
        {
          selector: 'node',
          style: {
            // 'display': 'none',
            'width': '50',
            'height': '50',

          }
        },
        {
          selector: 'node.label',
          style: {
            'label': 'data(label)',
            'text-margin-y': 5,
            'text-halign': 'center',
            'text-valign': 'bottom',
            'font-size': 13
          }
        },
        {
          selector: 'node.bigGraph',
          style: {
            'opacity': 0.5
          }
        },
        {
          selector: 'node.highlightOpen',
          style: {
            'overlay-color': '#e6e6e6',
            'overlay-opacity': 0.5,
            'overlay-padding': '2px'
          }
        },
        {
          selector: 'node.tooltip',
          style: {
            'overlay-color': '#ffffb3',
            'overlay-opacity': 0.5,
            'overlay-padding': '2px'
          }
        },
        {
          selector: 'node.iponimia',
          style: {
            'background-color': '#02768C'
          }
        },
        {
          selector: 'node.iponimiaDBClick',
          style: {
            'background-color': '#b8eaf2'
          }
        },
        {
          selector: 'node.meronimia',
          style: {
            'background-color': '#E49D00'
          }
        },
        {
          selector: 'node.meronimiaDBClick',
          style: {
            'background-color': '#f7dfaf'
          }
        },
        {
          selector: 'node.sinonimia',
          style: {
            'background-color': '#720040'
          }
        },
        {
          selector: 'node.sinonimiaDBClick',
          style: {
            'background-color': '#eab4d3'
          }
        },
        {
          selector: 'node.tutteRelazioni',
          style: {
            'background-color': '#07b207'
          }
        },
        {
          selector: 'node.2livello',
          style: {
            'opacity': 0
          }
        },
        {
          selector: 'node.1livello',
          style: {
            'opacity': 1
          }
        },
        {
          selector: 'node.grigio',
          style: {
            'background-color': 'grey'
          }
        },
        {
          selector: 'node.noLinkset',
          style: {
            'border-color': '#e62e00',
            'border-width': 2,
            'border-style': 'dashed'
          }
        },
        {
          selector: 'node.tutteRel_Iperonimi',
          style: {
            'background-color': '#047d95'
          }
        },
        {
          selector: 'node.tutteRel_Iponimi',
          style: {
            'background-color': '#03bde2'
          }
        },
        {
          selector: 'node.tutteRel_Meronimi',
          style: {
            'background-color': '#ffc266'
          }
        },
        {
          selector: 'node.tutteRel_Olonimi',
          style: {
            'background-color': '#cc7a00'
          }
        },
        {
          selector: 'node.tutteRel_Sinonimi',
          style: {
            'background-color': '#720040'
          }
        },
        {
          selector: 'node.sourceMinPath',
          style: {
            'border-color': '#ff9900',
            'border-width': 4,
            'border-style': 'solid'
          }
        },
        {
          selector: 'node.targetMinPath',
          style: {
            'border-color': '#0066ff',
            'border-width': 4,
            'border-style': 'solid'
          }
        },
        {
          selector: 'node.createdNode',
          style: {
            'background-color': 'grey'
          }
        },
        {
          selector: 'edge',
          style: {
            'target-arrow-shape': 'triangle',
            'curve-style': 'straight'
          }
        },
        {
          selector: 'edge.grigio',
          style: {
            'line-color': 'grey',
            'target-arrow-color': 'grey',
            'line-style': 'solid',
            'curve-style': 'bezier'
          }
        },
        {
          selector: 'edge.percorsoSelected',
          style: {
            'line-color': 'red',
            'target-arrow-color': 'red',
            'width': 4,
            'curve-style': 'bezier'
          }
        },
        {
          selector: 'edge.inferredPercorsoSelected',
          style: {
            'line-color': 'red',
            'target-arrow-color': 'red',
            'width': 4,
            'line-style':'dashed'
          }
        },
        {
          selector: 'edge.inferredConcettiInclusi',
          style: {
            'line-color': '#ff99ff',
            'target-arrow-color': '#ff99ff',
            'width': 4,
            'line-style':'dashed'
          }
        },
        {
          selector: 'edge.2livello',
          style: {
            'opacity': 0
          }
        },
        {
          selector: 'edge.1livello',
          style: {
            'opacity': 1
          }
        },
        {
          selector: 'edge.edges',
          style: {
            'line-color': "#e0e0d2",
            'target-arrow-color': '#e0e0d2',
            'line-style': 'solid'
          },
        },
        {
          selector: 'edge.highlight',
          style: {
            'line-color': '#ffff00',
            'target-arrow-color': '#ffff00'
          }
        },
        {
          selector: 'edge.inferred',
          style: {
            'line-color': 'grey',
            'target-arrow-color': 'grey',
            'curve-style': 'bezier',
            'line-style':'dashed'
          }
        },
        {
          selector: 'edge.iponimi',
          style: {
            'line-color': '#02768C',
            'target-arrow-color': '#02768C',
            'line-style': 'solid',
            'opacity': 0.5
          }
        },
        {
          selector: 'edge.meronimi',
          style: {
            'line-color': '#E49D00',
            'target-arrow-color': '#E49D00',
            'line-style': 'solid',
            'opacity': 0.5
          }
        },
        {
          selector: 'edge.sinonimi',
          style: {
            'line-color': '#720040',
            'target-arrow-color': '#720040',
            'line-style': 'solid',
            'opacity': 0.5,
            'curve-style': 'bezier'
          }
        },
        {
          selector: 'edge.crea_iponimi',
          style: {
            'line-color': '#02768C',
            'target-arrow-color': '#02768C',
            'line-style': 'solid',
            'opacity': 0.5,
            'curve-style': 'bezier'
          }
        },
        {
          selector: 'edge.crea_meronimi',
          style: {
            'line-color': '#E49D00',
            'target-arrow-color': '#E49D00',
            'line-style': 'solid',
            'opacity': 0.5,
            'curve-style': 'bezier'
          }
        },
        {
          selector: 'edge.crea_sinonimi',
          style: {
            'line-color': '#720040',
            'target-arrow-color': '#720040',
            'line-style': 'solid',
            'opacity': 0.5,
            'curve-style': 'bezier'
          }
        },
        {
          selector: 'edge.label',
          style: {
            'label': function (label) { return (label.data().label + "\n\n \ \u2060") },
            'text-background-opacity': 0,
            'text-wrap': 'wrap',
            'text-halign': 'center',
            'text-valign': 'bottom',
            'font-size': 13,
            'text-opacity': 1
          }
        },
        {
          selector: 'edge.concettiInclusi',
          style: {
            'line-color': '#ff99ff',
            'target-arrow-color': '#ff99ff',
          }
        },
        // some style for the extension
        {
          selector: '.eh-handle',
          style: {
            'background-color': 'yellow',
            'width': 12,
            'height': 12,
            'shape': 'ellipse',
            'overlay-opacity': 0,
            'border-width': 12, // makes the handle easier to hit
            'border-opacity': 0
          }
        },

        {
          selector: '.eh-hover',
          style: {
            'background-color': 'red'
          }
        },

        {
          selector: 'node.eh-source',
          style: {
            'border-width': 2,
            'border-color': 'red'
          }
        },

        {
          selector: 'node.eh-target',
          style: {
            'border-width': 2,
            'border-color': 'red'
          }
        },

        {
          selector: '.eh-preview, .eh-ghost-edge',
          style: {
            'background-color': 'red',
            'line-color': 'red',
            'target-arrow-color': 'red',
            'source-arrow-color': 'red'
          }
        },

        {
          selector: '.eh-ghost-edge.eh-preview-active',
          style: {
            'opacity': 0
          }
        }
      ],
    });

    // fix refresh pagina, cancella il sessionstorage
    window.onunload = function () {
      sessionStorage.clear();
    }
    // estensione dbclick
    this.cy.dblclick();

    // permette all'utente di spostare l'intero grafo con il mouse
    this.cy.userPanningEnabled(true);

    // estensione context menu
    this.contextMenu = this.cy.contextMenus(this.istanzaCtxMenu.ctxMenu);

    this.cy.on("mouseover", 'node.iponimiaDBClick,node.iponimia,node.meronimiaDBClick,node.meronimia,node.sinonimiaDBClick,node.sinonimia,node.tutteRelazioni,node.tutteRel_Iperonimi,node.tutteRel_Iponimi,node.tutteRel_Meronimi,node.tutteRel_Olonimi,node.tutteRel_Sinonimi', (event) => {
      event.target.popperRefObj = event.target.popper({
        placement: 'top',
        content: () => {
          let content = document.createElement('div');
          that.dataStorageService.fetchInfoNode(event.target.data().id).subscribe(infoNodo => {
            content.classList.add("popper-div");
            content.innerHTML = infoNodo.definition;
          });
          document.body.appendChild(content);
          return content;
        },
        popper: {
          placement: 'top-start',
          strategy: 'absolute',
        }
      });
    });

    // solo per visualizzazione multipla con classe node grigio, visualizzo tooltip con id e definition
    this.cy.on("mouseover", 'node.grigio', (event) => {
      event.target.popperRefObj = event.target.popper({
        placement: 'top',
        content: () => {
          let content = document.createElement('div');
          that.dataStorageService.fetchInfoNode(event.target.data().id).subscribe(infoNodo => {
            content.classList.add("popper-div");
            content.innerHTML = `<p>` + infoNodo.id + `</p>` + infoNodo.definition;
          });
          document.body.appendChild(content);
          return content;
        },
        popper: {
          placement: 'top-start',
          strategy: 'absolute',
        }
      });
    });

    // solo per visualizzazione multipla con classe node grigio, visualizzo tooltip con id e definition
    // this.cy.on("mouseover", 'edge.percorsoSelected,edge.grigio,edge.concettiInclusi,edge.inferred,edge.inferredConcettiInclusi,edge.inferredPercorsoSelected', (event) => {
    //   const edge = event.target;
    //   event.target.popperRefObj = event.target.popper({
    //     placement: 'top',
    //     content: () => {
    //       let content = document.createElement('div');
    //       content.classList.add("popper-div-edge");
    //       content.innerHTML = edge.data().relationType;
    //       document.body.appendChild(content);
    //       return content;
    //     },
    //     popper: {
    //       placement: 'top-start',
    //       strategy: 'absolute',
    //     }
    //   });
    // });

    this.cy.on("mouseout", 'node.iponimiaDBClick,node.iponimia,node.meronimiaDBClick,node.meronimia,node.sinonimiaDBClick,node.sinonimia,node.tutteRelazioni,node.tutteRel_Iperonimi,node.tutteRel_Iponimi,node.tutteRel_Meronimi,node.tutteRel_Olonimi,node.tutteRel_Sinonimi,node.grigio', (event) => {
      if (event.target.popper) {
        event.target.popperRefObj.state.elements.popper.remove();
        event.target.popperRefObj.destroy();
      }
    });
    this.cy.on("tap", 'node.iponimiaDBClick,node.iponimia,node.meronimiaDBClick,node.meronimia,node.sinonimiaDBClick,node.sinonimia,node.tutteRelazioni,node.tutteRel_Iperonimi,node.tutteRel_Iponimi,node.tutteRel_Meronimi,node.tutteRel_Olonimi,node.tutteRel_Sinonimi,node.grigio', (event) => {
      if (event.target.popper) {
        event.target.popperRefObj.state.elements.popper.remove();
        event.target.popperRefObj.destroy();
      }
    });

    // dbl clic tranne tutte relazioni
    this.cy.on('dblclick', 'node.iponimiaDBClick,node.iponimia,node.meronimiaDBClick,node.meronimia,node.sinonimiaDBClick,node.sinonimia'
      , function (event) {
        that.spinner.showSpinner();
        // ricevo un doppio click
        let nodoDBClick = event.target;
        let edgesInferred: boolean[];
        nodoDBClick.removeClass('2livello');
        nodoDBClick.addClass('1livello');
        // chiamate multiple
        let serverData1 = that.dataStorageService.fetchSubGraph(nodoDBClick.data().id, that.relationType, 1, "incoming")
        let serverData2 = that.dataStorageService.fetchSubGraph(nodoDBClick.data().id, that.relationType, 1, "outgoing")
        const arr = [serverData1, serverData2]
        let multiCall = forkJoin(arr)
        // stato 1
        if (sessionStorage.getItem('focusNode') === event.target.data().id) {
          console.log('STATO 1 - 1');
          sessionStorage.setItem('focusNode', event.target.data().id);
          that.arrayNodi = [];
          that.arrayEdge = [];
          that.arrayIponimia = [];
          that.arrayMeronimia = [];
          that.arraySinonimia = [];

          that.statoNodiIpo = JSON.parse(sessionStorage.getItem("statoNodiIpo"));
          that.statoEdgeIpo = JSON.parse(sessionStorage.getItem("statoEdgeIpo"));

          that.statoNodiMero = JSON.parse(sessionStorage.getItem("statoNodiMero"));
          that.statoEdgeMero = JSON.parse(sessionStorage.getItem("statoEdgeMero"));

          that.statoNodiSino = JSON.parse(sessionStorage.getItem("statoNodiSino"));
          that.statoEdgeSino = JSON.parse(sessionStorage.getItem("statoEdgeSino"));

          this.statoTutteRelazioni = null;

          if (that.relationType === 'hyponym' && that.statoNodiIpo === null ||
            that.relationType === 'partMeronym' && that.statoNodiMero === null ||
            that.relationType === 'synonym' && that.statoNodiSino === null
          ) {
            that.sub1 = multiCall.subscribe(subGraph => {
              let incoming: any = subGraph[0].edges;
              let outgoing: any = subGraph[1].edges;
              if (subGraph) {
                that.spinner.hideSpinner();
              }
              // disabilito form distanza se non ci sono nodi con lunghezza
              if (incoming.length === 0) {
                if (that.relationType === 'hyponym') {
                  that.istanzaHeaderC.relazioneIponimiaDistanza.controls['iponimo'].disable();
                }
                if (that.relationType === 'partMeronym') {
                  that.istanzaHeaderC.relazioneMeronimiaDistanza.controls['meronimo'].disable();
                }
              }
              if (outgoing.length === 0) {
                if (that.relationType === 'hyponym') {
                  that.istanzaHeaderC.relazioneIponimiaDistanza.controls['iperonimo'].disable();
                }
                if (that.relationType === 'partMeronym') {
                  that.istanzaHeaderC.relazioneMeronimiaDistanza.controls['olonimo'].disable();
                }
              }
              subGraph.map(subGraph => {
                if (that.relationType === 'hyponym') {
                  // controllo per settare a 1 il livello di distanza
                  for (var i = 0; i < subGraph.edges.length; i++) {
                    if (subGraph.edges[i].data.source !== nodoDBClick.data().id) {
                      that.istanzaHeaderC.relazioneIponimiaDistanza.get('iponimo').setValue(1);
                    } else {
                      that.istanzaHeaderC.relazioneIponimiaDistanza.get('iperonimo').setValue(1);
                    }
                  }
                }
                if (that.relationType === 'partMeronym') {
                  for (var i = 0; i < subGraph.edges.length; i++) {
                    if (subGraph.edges[i].data.source !== nodoDBClick.data().id) {
                      that.istanzaHeaderC.relazioneMeronimiaDistanza.get('meronimo').setValue(1);
                    } else {
                      that.istanzaHeaderC.relazioneMeronimiaDistanza.get('olonimo').setValue(1);
                    }
                  }
                }
                let nodi = subGraph.nodes;
                let edges = subGraph.edges;
                edgesInferred = subGraph.edges.map(ele => {
                  return ele.data.inferred
                });
                // nodi > 1000
                if (nodi.length > 1000) {
                  alert('attenzioni nodi > 1000, il caricamento dei sensi viene fermato')
                  that.spinner.hideSpinner();
                  if (incoming.length > 999) {
                    // resetto valore a 0 
                    that.istanzaDistanzaIpo.valoreFormIpom.emit(0);
                  }
                  if (outgoing.length > 999) {
                    // resetto valore a 0 
                    that.istanzaDistanzaIpo.valoreFormIper.emit(0);
                  }
                  // nodi < 1000
                } else {
                  for (var i = 0; i < nodi.length; i++) {
                    // aggiungo nodi
                    that.cy.add([{
                      group: "nodes",
                      data: {
                        id: subGraph.nodes[i].data.id,
                        label: subGraph.nodes[i].data.label
                      }
                    }]);
                    // aggiungo nodi ad array nodi
                    that.arrayNodi.length = that.arrayNodi.push(subGraph.nodes[i].data.id);

                    // salvo gli elementi negli array delle relazioni
                    // alla selezione di un radio button della relazione,
                    // rimuovo elementi delle relazioni che non mi interessano, così rimuovo lo spazio occupato dai nodi nascosti
                    if (that.relationType === 'hyponym') {
                      that.arrayIponimia.length = that.arrayIponimia.push(subGraph.nodes[i].data.id);
                      sessionStorage.setItem("statoNodiIpo", JSON.stringify(that.arrayIponimia.length));
                    }
                    if (that.relationType === 'partMeronym') {
                      that.arrayMeronimia.length = that.arrayMeronimia.push(subGraph.nodes[i].data.id);
                      sessionStorage.setItem("statoNodiMero", JSON.stringify(that.arrayMeronimia.length));
                    }
                    if (that.relationType === 'synonym') {
                      that.arraySinonimia.length = that.arraySinonimia.push(subGraph.nodes[i].data.id);
                      sessionStorage.setItem("statoNodiSino", JSON.stringify(that.arraySinonimia.length));
                    }
                    that.cy.getElementById(subGraph.nodes[i].data.id).style('display', 'element');
                  }

                  for (var i = 0; i < edges.length; i++) {
                    // aggiungo edge
                    that.cy.add([{
                      group: "edges",
                      data: {
                        id: subGraph.edges[i].data.id,
                        source: subGraph.edges[i].data.source,
                        target: subGraph.edges[i].data.target,
                        label: subGraph.edges[i].data.relationType
                      }
                    }]);
                    // aggiungo edge ad array di edges
                    that.arrayEdge.length = that.arrayEdge.push(that.cy.getElementById(subGraph.edges[i].data.id));
                    that.cy.getElementById(subGraph.edges[i].data.id).style('display', 'element');
                    if (that.relationType === 'hyponym') {
                      sessionStorage.setItem("statoEdgeIpo", JSON.stringify(that.arrayEdge.length));
                    }
                    if (that.relationType === 'partMeronym') {
                      sessionStorage.setItem("statoEdgeMero", JSON.stringify(that.arrayEdge.length));
                    }
                    if (that.relationType === 'synonym') {
                      sessionStorage.setItem("statoEdgeSino", JSON.stringify(that.arrayEdge.length));
                    }

                    let nodiConnessi = that.cy.getElementById(edges[i].data.id).connectedNodes();
                    let archi = that.cy.getElementById(edges[i].data.id);
                    nodiConnessi.addClass('label');
                    if (edges[i].data.relationType === 'hyponym') {
                      that.cy.batch(function () {
                        nodiConnessi
                          .removeClass('meronimia')
                          .removeClass('sinonimia')
                          .removeClass('meronimiaDBClick')
                          .removeClass('sinonimiaDBClick')
                          .removeClass('tutteRelazioni')
                          .addClass('iponimia')
                          ;
                      });

                      that.cy.batch(function () {
                        archi
                          .removeClass('2livello')
                          .removeClass("inferred")
                          .addClass("edges")
                          ;
                      });
                      nodoDBClick.style('display', 'element');
                      nodoDBClick.addClass('iponimiaDBClick');
                    }
                    if (edges[i].data.relationType === 'partMeronym') {
                      that.cy.batch(function () {
                        nodiConnessi
                          .removeClass('iponimia')
                          .removeClass('sinonimia')
                          .removeClass('iponimiaDBClick')
                          .removeClass('sinonimiaDBClick')
                          .removeClass('tutteRelazioni')
                          .addClass('meronimia')
                          ;
                      });
                      that.cy.batch(function () {
                        archi
                          .removeClass('2livello')
                          .removeClass("inferred")
                          .addClass("edges")
                          ;
                      });
                      nodoDBClick.style('display', 'element');
                      nodoDBClick.addClass('meronimiaDBClick');
                    }
                    // nodi inferiti visibili SOLO nella relazione di sinonimia
                    if (edges[i].data.relationType === 'synonym') {
                      that.cy.batch(function () {
                        nodiConnessi
                          .removeClass('meronimia')
                          .removeClass('iponimia')
                          .removeClass('meronimiaDBClick')
                          .removeClass('iponimiaDBClick')
                          .removeClass('tutteRelazioni')
                          .addClass('sinonimia')
                          ;
                      });
                      that.cy.getElementById(subGraph.edges[i].data.id).removeClass('2livello');
                      nodoDBClick.addClass('sinonimiaDBClick');
                      if (edgesInferred[i] === true) {
                        that.cy.getElementById(subGraph.edges[i].data.id).addClass("inferred");
                      } else {
                        that.cy.batch(function () {
                          archi
                            .removeClass("inferred")
                            .addClass("edges")
                            ;
                        });
                      }
                    }
                  }
                  if (that.relationType === 'hyponym' || that.relationType === 'partMeronym') {
                    that.posizioni_dbClic.posizioni(event);
                    if (nodoDBClick.connectedEdges().toArray().length > 20 && nodoDBClick.connectedEdges().toArray().length < 200) {
                      that.cy.fit();
                    } else if (nodoDBClick.connectedEdges().toArray().length > 200 && nodoDBClick.connectedEdges().toArray().length < 500) {
                      that.cy.fit();
                    }
                    else {
                      that.cy.zoom({
                        level: 1.0,
                      });
                      that.cy.center();
                      if (that.isGraphOutOfView() === true) {
                        that.cy.fit();
                      }
                    }
                  }

                  if (that.relationType === 'synonym') {
                    that.layoutSinonimi = nodoDBClick.incomers().sources().layout({
                      name: 'circle',
                      padding: 250,
                      avoidOverlap: true,
                      radius: 10,
                      startAngle: 3 / 2 * Math.PI,
                      sweep: undefined,
                      clockwise: true,

                    });
                    that.layoutSinonimi.run();
                  }
                }

              });
            });

          } else {
            console.log('STATO 1 - 2');
            that.cy.remove(that.cy.elements(':visible'));
            nodoDBClick.restore();
            if (that.relationType === 'hyponym') {
              that.disabIpe = false;
              that.disabIpo = false;
              sessionStorage.removeItem("statoNodiIpo");
              sessionStorage.removeItem('statoEdgeIpo');
              // se form disabilitato lo riabilito
              if (that.istanzaHeaderC.relazioneIponimiaDistanza.controls['iponimo'].disabled === true) {
                that.istanzaHeaderC.relazioneIponimiaDistanza.controls['iponimo'].enable();
              }
              if (that.istanzaHeaderC.relazioneIponimiaDistanza.controls['iperonimo'].disabled === true) {
                that.istanzaHeaderC.relazioneIponimiaDistanza.controls['iperonimo'].enable();
              }
            }
            if (that.relationType === 'partMeronym') {
              that.disabMero = false;
              that.disabOlo = false;
              sessionStorage.removeItem("statoNodiMero");
              sessionStorage.removeItem('statoEdgeMero');
              sessionStorage.removeItem('statoMeronimi');
              sessionStorage.removeItem('statoOlonimi');
              // se form disabilitato lo riabilito
              if (that.istanzaHeaderC.relazioneMeronimiaDistanza.controls['meronimo'].disabled === true) {
                that.istanzaHeaderC.relazioneMeronimiaDistanza.controls['meronimo'].enable()
              }
              if (that.istanzaHeaderC.relazioneMeronimiaDistanza.controls['olonimo'].disabled === true) {
                that.istanzaHeaderC.relazioneMeronimiaDistanza.controls['olonimo'].enable()
              }
            }
            if (that.relationType === 'synonym') {
              sessionStorage.removeItem("statoNodiSino");
              sessionStorage.removeItem('statoEdgeSino');
            }

            if (that.relationType === 'tutteRelazioni') {
              that.istanzaHeaderC.tutteRelazioni.controls['relazioni'].setValue(0);
            }
            that.spinner.hideSpinner();
            that.resettoFormDistanza();
            that.cy.zoom({
              level: 1.0,
            });
            that.cy.center(nodoDBClick);
          }
        }
        // stato 2
        else {
          console.log('STATO 2 ');
          sessionStorage.setItem('focusNode', event.target.data().id);
          that.arrayIponimia = [];
          that.arrayMeronimia = [];
          that.arraySinonimia = [];
          that.arrayNodi2livello = [];
          that.arrayEdge2livello = [];
          that.statoNodiIpo = JSON.parse(sessionStorage.getItem("statoNodiIpo"));
          that.statoEdgeIpo = JSON.parse(sessionStorage.getItem("statoEdgeIpo"));

          that.statoNodiMero = JSON.parse(sessionStorage.getItem("statoNodiMero"));
          that.statoEdgeMero = JSON.parse(sessionStorage.getItem("statoEdgeMero"));

          that.statoNodiSino = JSON.parse(sessionStorage.getItem("statoNodiSino"));
          that.statoEdgeSino = JSON.parse(sessionStorage.getItem("statoEdgeSino"));

          let serverData1_2st = that.dataStorageService.fetchSubGraph(sessionStorage.getItem('focusNode'), that.relationType, 1, "incoming")
          let serverData2_2st = that.dataStorageService.fetchSubGraph(sessionStorage.getItem('focusNode'), that.relationType, 1, "outgoing")
          const arr_2st = [serverData1_2st, serverData2_2st]
          let multiCall_2st = forkJoin(arr_2st)
          // se lo stato non è null vuol dire che c'è stato un db clic
          if (that.statoNodiIpo !== null ||
            that.statoNodiMero !== null ||
            that.statoNodiSino !== null
          ) {
            that.sub1 = multiCall_2st.subscribe(subGraph => {
              let incoming: any = subGraph[0].edges;
              let outgoing: any = subGraph[1].edges;
              if (subGraph) {
                that.spinner.hideSpinner();
              }
              // disabilito form distanza se non ci sono nodi con lunghezza
              if (incoming.length === 0) {
                if (that.relationType === 'hyponym') {
                  that.istanzaHeaderC.relazioneIponimiaDistanza.controls['iponimo'].disable();
                  that.istanzaHeaderC.relazioneIponimiaDistanza.get('iponimo').setValue(0);
                }
                if (that.relationType === 'partMeronym') {
                  that.istanzaHeaderC.relazioneMeronimiaDistanza.controls['meronimo'].disable();
                  that.istanzaHeaderC.relazioneMeronimiaDistanza.get('meronimo').setValue(0);
                }
              } else {
                if (that.relationType === 'hyponym') {
                  that.istanzaHeaderC.relazioneIponimiaDistanza.controls['iponimo'].enable();
                  that.istanzaHeaderC.relazioneIponimiaDistanza.get('iponimo').setValue(1);
                }
                if (that.relationType === 'partMeronym') {
                  that.istanzaHeaderC.relazioneMeronimiaDistanza.controls['meronimo'].enable();
                  that.istanzaHeaderC.relazioneMeronimiaDistanza.get('meronimo').setValue(1);
                }
              }
              if (outgoing.length === 0) {
                if (that.relationType === 'hyponym') {
                  that.istanzaHeaderC.relazioneIponimiaDistanza.controls['iperonimo'].disable();
                  that.istanzaHeaderC.relazioneIponimiaDistanza.get('iperonimo').setValue(0);
                }
                if (that.relationType === 'partMeronym') {
                  that.istanzaHeaderC.relazioneMeronimiaDistanza.controls['olonimo'].disable();
                  that.istanzaHeaderC.relazioneMeronimiaDistanza.get('olonimo').setValue(0);
                }
              } else {
                if (that.relationType === 'hyponym') {
                  that.istanzaHeaderC.relazioneIponimiaDistanza.controls['iperonimo'].enable();
                  that.istanzaHeaderC.relazioneIponimiaDistanza.get('iperonimo').setValue(1);
                }
                if (that.relationType === 'partMeronym') {
                  that.istanzaHeaderC.relazioneMeronimiaDistanza.controls['olonimo'].enable();
                  that.istanzaHeaderC.relazioneMeronimiaDistanza.get('olonimo').setValue(1);
                }
              }
              // nodi > 1000
              if (incoming.length > 1000 || outgoing.length > 1000) {
                alert('attenzione nodi > 1000, il caricamento dei sensi viene fermato')
                that.spinner.hideSpinner();
              }
              // nodi < 1000 
              else {
                // nascondo nodi secondo livello
                nodoDBClick.outgoers().targets().successors().style('display', 'none');
                nodoDBClick.incomers().sources().predecessors().style('display', 'none');
                nodoDBClick.outgoers().targets().predecessors().style('display', 'none');
                nodoDBClick.incomers().sources().successors().style('display', 'none');
                subGraph.map(subGraph => {
                  let nodi = subGraph.nodes;
                  let edges = subGraph.edges;
                  edgesInferred = subGraph.edges.map(ele => {
                    return ele.data.inferred
                  });
                  for (var i = 0; i < nodi.length; i++) {
                    // aggiungo nodi
                    that.cy.add([{
                      group: "nodes",
                      data: {
                        id: subGraph.nodes[i].data.id,
                        label: subGraph.nodes[i].data.label
                      }
                    }]);
                    // aggiungo nodi ad array nodi
                    that.arrayNodi2livello.length = that.arrayNodi2livello.push(subGraph.nodes[i].data.id);
                    that.arrayNodi.length = that.arrayNodi.push(subGraph.nodes[i].data.id);
                    // salvo gli elementi negli array delle relazioni
                    // alla selezione di un radio button della relazione,
                    // rimuovo elementi delle relazioni che non mi interessano, così rimuovo lo spazio occupato dai nodi nascosti
                    if (that.relationType === 'hyponym') {
                      that.arrayIponimia.length = that.arrayIponimia.push(subGraph.nodes[i].data.id);
                      sessionStorage.setItem("statoNodiIpo", JSON.stringify(that.arrayIponimia.length));
                    }
                    if (that.relationType === 'partMeronym') {
                      that.arrayMeronimia.length = that.arrayMeronimia.push(subGraph.nodes[i].data.id);
                      sessionStorage.setItem("statoNodiMero", JSON.stringify(that.arrayMeronimia.length));
                    }
                    if (that.relationType === 'synonym') {
                      that.arraySinonimia.length = that.arraySinonimia.push(subGraph.nodes[i].data.id);
                      sessionStorage.setItem("statoNodiSino", JSON.stringify(that.arraySinonimia.length));
                    }

                    that.cy.getElementById(subGraph.nodes[i].data.id).style('display', 'element');
                    // rimuovo classe grigio (se è stato cliccato db click dopo ctx menu)
                    that.cy.getElementById(subGraph.nodes[i].data.id).removeClass('grigio');
                  }
                  for (var i = 0; i < that.arrayNodi2livello.length; i++) {
                    that.cy.getElementById(that.arrayNodi2livello[i]).style('display', 'element');
                  }
                  for (var i = 0; i < edges.length; i++) {
                    // aggiungo edge
                    that.cy.add([{
                      group: "edges",
                      data: {
                        id: subGraph.edges[i].data.id,
                        source: subGraph.edges[i].data.source,
                        target: subGraph.edges[i].data.target,
                        label: subGraph.edges[i].data.relationType
                      }
                    }]);
                    // aggiungo edge ad array di edges
                    that.arrayEdge2livello.length = that.arrayEdge2livello.push(that.cy.getElementById(subGraph.edges[i].data.id));
                    that.arrayEdge.length = that.arrayEdge.push(that.cy.getElementById(subGraph.edges[i].data.id));
                    that.cy.getElementById(subGraph.edges[i].data.id).style('display', 'element');
                    if (that.relationType === 'hyponym') {
                      sessionStorage.setItem("statoEdgeIpo", JSON.stringify(that.arrayEdge.length));
                    }
                    if (that.relationType === 'partMeronym') {
                      sessionStorage.setItem("statoEdgeMero", JSON.stringify(that.arrayEdge.length));
                    }
                    if (that.relationType === 'synonym') {
                      sessionStorage.setItem("statoEdgeSino", JSON.stringify(that.arrayEdge.length));
                    }
                    let nodiConnessi = that.cy.getElementById(edges[i].data.id).connectedNodes();
                    let archi = that.cy.getElementById(edges[i].data.id);
                    nodiConnessi.addClass('label');
                    if (edges[i].data.relationType === 'hyponym') {
                      that.cy.batch(function () {
                        nodiConnessi
                          .removeClass('meronimia')
                          .removeClass('sinonimia')
                          .removeClass('meronimiaDBClick')
                          .removeClass('sinonimiaDBClick')
                          .removeClass('tutteRelazioni')
                          .addClass('iponimia')
                          ;
                      });
                      that.cy.batch(function () {
                        archi
                          .removeClass('2livello')
                          .removeClass("inferred")
                          .addClass("edges")
                          ;
                      });
                      nodoDBClick.style('display', 'element');
                      nodoDBClick.addClass('iponimiaDBClick');
                    }
                    if (edges[i].data.relationType === 'partMeronym') {
                      that.cy.batch(function () {
                        nodiConnessi
                          .removeClass('iponimia')
                          .removeClass('sinonimia')
                          .removeClass('iponimiaDBClick')
                          .removeClass('sinonimiaDBClick')
                          .removeClass('tutteRelazioni')
                          .addClass('meronimia')
                          ;
                      });
                      that.cy.batch(function () {
                        archi
                          .removeClass('2livello')
                          .removeClass("inferred")
                          .addClass("edges")
                          ;
                      });
                    }
                    // nodi inferiti visibili SOLO nella relazione di sinonimia
                    if (edges[i].data.relationType === 'synonym') {
                      that.cy.batch(function () {
                        nodiConnessi
                          .removeClass('meronimia')
                          .removeClass('iponimia')
                          .removeClass('meronimiaDBClick')
                          .removeClass('iponimiaDBClick')
                          .removeClass('tutteRelazioni')
                          .addClass('sinonimia')
                          ;
                      });
                      nodoDBClick.addClass('sinonimiaDBClick');
                      if (edgesInferred[i] === true) {
                        that.cy.getElementById(subGraph.edges[i].data.id).addClass("inferred");
                      } else {
                        that.cy.batch(function () {
                          archi
                            .removeClass("inferred")
                            .addClass("edges")
                            ;
                        });
                      }
                    }
                  }
                  // }
                  if (that.relationType === 'hyponym' || that.relationType === 'partMeronym') {
                    that.posizioni_dbClic.posizioni(event);
                    if (nodoDBClick.connectedEdges().toArray().length > 20 && nodoDBClick.connectedEdges().toArray().length < 200) {
                      that.cy.fit();
                    } else if (nodoDBClick.connectedEdges().toArray().length > 200 || nodoDBClick.connectedEdges().toArray().length > 200) {
                      that.cy.fit();
                    } else {
                      that.cy.zoom({
                        level: 1.0,
                      });
                      that.cy.center();
                    }
                    if (that.isGraphOutOfView() === true) {
                      that.cy.fit();
                    }
                  }
                  if (that.relationType === 'synonym') {
                    that.layoutSinonimi = nodoDBClick.incomers().sources().layout({
                      name: 'circle',
                      padding: 250,
                      avoidOverlap: true,
                      radius: 10,
                      startAngle: 3 / 2 * Math.PI,
                      sweep: undefined,
                      clockwise: true,
                    });
                    that.layoutSinonimi.run();
                  }


                });
              }
            });
          }
        }
      }
    );

    // dbl clic SOLO per tutte relazioni
    this.cy.on('dblclick', 'node.tutteRelazioni,node.tutteRel_Iperonimi,node.tutteRel_Iponimi,node.tutteRel_Meronimi,node.tutteRel_Olonimi,node.tutteRel_Sinonimi', function (evt) {
      that.istanzaHeaderC.tutteRelazioni.get('relazioni').setValue(1);
      let nodoDBClick = evt.target;
      sessionStorage.setItem('focusNode', evt.target.data().id)
      sessionStorage.getItem('statoTutteRelazioni');
      that.statoTutteRelazioni = JSON.parse(sessionStorage.getItem("statoTutteRelazioni"));
      if (that.statoTutteRelazioni === null) {
        that.istanzaHeaderC.tutteRelazioni.get('relazioni').setValue(1)
        that.istanzaHeaderC.relazioni();
        that.cy.batch(function () {
          nodoDBClick
            .removeClass('tutteRel_Iperonimi')
            .removeClass('tutteRel_Iponimi')
            .removeClass('tutteRel_Meronimi')
            .removeClass('tutteRel_Olonimi')
            .removeClass('tutteRel_Sinonimi')
            .removeClass('iponimia')
            .removeClass('iponimiaDbClick')
            .addClass('tutteRelazioni')
            ;
        });
      } else {
        console.log('stato 2 ')
        that.cy.remove(that.cy.elements(':visible'));
        nodoDBClick.restore();
        sessionStorage.removeItem('statoTutteRelazioni')
        that.istanzaHeaderC.tutteRelazioni.get('relazioni').setValue(0)
      }
    });

    // recupero info nodo al clic sul nodo di interesse
    this.cy.on('click', 'node.iponimiaDBClick,node.iponimia,node.meronimiaDBClick,node.meronimia,node.sinonimiaDBClick,node.sinonimia,node.tutteRelazioni,node.tutteRel_Iperonimi,node.tutteRel_Iponimi,node.tutteRel_Meronimi,node.tutteRel_Olonimi,node.tutteRel_Sinonimi,node.grigio', function (evt) {
      that.clicks++;
      // se clic è singolo apro il panel box
      if (that.clicks === 1) {
        that.timer = setTimeout(function () {
          that.clicks = 0;
          const panel = document.getElementById('panel');
          const node = evt.target;
          if (!this.currentEle || this.currentEle?.id !== node.data().id) {//se ho cliccato sullo stesso elemento di prima per prendere solo id node.data().id
            // richiesta http per recuperare info nodo da visualizzare
            that.dataStorageService.fetchInfoNode(node.data().id).pipe(take(1)).subscribe(infoNodo => { //prendo una volta (take 1) così non devo fare unsubscribe nell'ondestroy
              this.currentEle = infoNodo;
              node.flashClass("highlightOpen", 2000);
              //stringhe con variabili all'interno, quello inserito tra $ e par graffa deve essere variabile o espressione ecc.
              if (infoNodo.links.length !== 0) {
                if (infoNodo.links[0].inferred === true && infoNodo.links[1].inferred === false) {
                  // relazioni non inferite
                  var iperonimi;
                  var iperonimiTargets;
                  var iponimi;
                  var iponimiTargets;
                  var meronimi;
                  var meronimiTargets;
                  var olonimi;
                  var olonimiTargets;
                  var sinoUscenti;
                  var sinoUscentiTargets;
                  var sinoEntranti;
                  var sinoEntrantiTargets;
                  // iperonimi count e targets
                  infoNodo.links[1].nodeLinks.map(el => {
                    if (el.linkType === 'outgoing' &&
                      el.linkName === 'hyponym') {
                      iperonimi = el.linkCount
                      iperonimiTargets = '';
                      for (var i = 0; i < el.targets.length; i++) {
                        iperonimiTargets += el.targets[i].label + '</br>'
                      }
                      return iperonimi && iperonimiTargets
                    }
                  });
                  // iponimi count e targets
                  infoNodo.links[1].nodeLinks.map(el => {
                    if (el.linkType === 'incoming' &&
                      el.linkName === 'hyponym') {
                      iponimi = el.linkCount
                      iponimiTargets = '';
                      for (var i = 0; i < el.targets.length; i++) {
                        iponimiTargets += el.targets[i].label + '</br>'
                      }
                      return iponimi && iponimiTargets
                    }
                  });

                  // meronimi count e targets
                  infoNodo.links[1].nodeLinks.map(el => {
                    if (el.linkType === 'incoming' &&
                      el.linkName === 'meronym') {
                      meronimi = el.linkCount
                      meronimiTargets = '';
                      for (var i = 0; i < el.targets.length; i++) {
                        meronimiTargets += el.targets[i].label + '</br>'
                      }
                      return meronimi && meronimiTargets
                    }
                  });

                  // olonimi count e targets
                  infoNodo.links[1].nodeLinks.map(el => {
                    if (el.linkType === 'outgoing' &&
                      el.linkName === 'holonym') {
                      olonimi = el.linkCount
                      olonimiTargets = '';
                      for (var i = 0; i < el.targets.length; i++) {
                        olonimiTargets += el.targets[i].label + '</br>'
                      }
                      return olonimi && olonimiTargets
                    }
                  });

                  // sinonimi uscenti count e targets
                  infoNodo.links[1].nodeLinks.map(el => {
                    if (el.linkType === 'outgoing' &&
                      el.linkName === 'synonym') {
                      sinoUscenti = el.linkCount;
                      sinoUscentiTargets = '';
                      for (var i = 0; i < el.targets.length; i++) {
                        sinoUscentiTargets += el.targets[i].label + '</br>'
                      }
                      return sinoUscenti && sinoUscentiTargets
                    }
                  });

                  // sinonimi entranti count e targets
                  infoNodo.links[1].nodeLinks.map(el => {
                    if (el.linkType === 'incoming' &&
                      el.linkName === 'synonym') {
                      sinoEntranti = el.linkCount;
                      sinoEntrantiTargets = '';
                      for (var i = 0; i < el.targets.length; i++) {
                        sinoEntrantiTargets += el.targets[i].label + '</br>'
                      }
                      return sinoEntranti && sinoEntrantiTargets
                    }
                  });

                  // relazioni inferite
                  var iperonimiInf;
                  var iperonimiTargetsInf;
                  var iponimiInf;
                  var iponimiTargetsInf;
                  var meronimiInf;
                  var meronimiTargetsInf;
                  var olonimiInf;
                  var olonimiTargetsInf;
                  var sinoUscentiInf;
                  var sinoUscentiTargetsInf;
                  var sinoEntrantiInf;
                  var sinoEntrantiTargetsInf;
                  // iperonimi count e targets
                  infoNodo.links[0].nodeLinks.map(el => {
                    if (el.linkType === 'outgoing' &&
                      el.linkName === 'hyponym') {
                      iperonimiInf = el.linkCount
                      iperonimiTargetsInf = '';
                      for (var i = 0; i < el.targets.length; i++) {
                        iperonimiTargetsInf += el.targets[i].label + '</br>'
                      }
                      return iperonimiInf && iperonimiTargetsInf
                    }
                  });
                  // iponimi count e targets
                  infoNodo.links[0].nodeLinks.map(el => {
                    if (el.linkType === 'incoming' &&
                      el.linkName === 'hyponym') {
                      iponimiInf = el.linkCount
                      iponimiTargetsInf = '';
                      for (var i = 0; i < el.targets.length; i++) {
                        iponimiTargetsInf += el.targets[i].label + '</br>'
                      }
                      return iponimiInf && iponimiTargetsInf
                    }
                  });

                  // meronimi count e targets
                  infoNodo.links[0].nodeLinks.map(el => {
                    if (el.linkType === 'incoming' &&
                      el.linkName === 'meronym') {
                      meronimiInf = el.linkCount
                      meronimiTargetsInf = '';
                      for (var i = 0; i < el.targets.length; i++) {
                        meronimiTargetsInf += el.targets[i].label + '</br>'
                      }
                      return meronimiInf && meronimiTargetsInf
                    }
                  });

                  // olonimi count e targets
                  infoNodo.links[0].nodeLinks.map(el => {
                    if (el.linkType === 'incoming' &&
                      el.linkName === 'holonym') {
                      olonimiInf = el.linkCount
                      olonimiTargetsInf = '';
                      for (var i = 0; i < el.targets.length; i++) {
                        olonimiTargetsInf += el.targets[i].label + '</br>'
                      }
                      return olonimiInf && olonimiTargetsInf
                    }
                  });

                  // sinonimi uscenti count e targets
                  infoNodo.links[0].nodeLinks.map(el => {
                    if (el.linkType === 'outgoing' &&
                      el.linkName === 'synonym') {
                      sinoUscentiInf = el.linkCount;
                      sinoUscentiTargetsInf = '';
                      for (var i = 0; i < el.targets.length; i++) {
                        sinoUscentiTargetsInf += el.targets[i].label + '</br>'
                      }
                      return sinoUscentiInf && sinoUscentiTargetsInf
                    }
                  });

                  // sinonimi entranti count e targets
                  infoNodo.links[0].nodeLinks.map(el => {
                    if (el.linkType === 'incoming' &&
                      el.linkName === 'synonym') {
                      sinoEntrantiInf = el.linkCount;
                      sinoEntrantiTargetsInf = '';
                      for (var i = 0; i < el.targets.length; i++) {
                        sinoEntrantiTargetsInf += el.targets[i].label + '</br>'
                      }
                      return sinoEntrantiInf && sinoEntrantiTargetsInf
                    }
                  });

                  panel.innerHTML = `<div id ="x" style="padding-left: 95%;cursor:pointer"> X </div>
                <p><b>Sense</b> : ${this.currentEle.label} </p><p><b>Id</b> : ${this.currentEle.id} </p>
                <p><b>Definition</b> : ${this.currentEle.definition} </p><p><b>POS</b> : ${this.currentEle.pos} </p>
                <p><b>IRI</b> : ${this.currentEle.iri} </p>
                <p style="color:#980000"><b>Semantic relations </b> :</p>
                <b><em>Hypernym</em></b> : ${iperonimi} </br>
                <p>${iperonimiTargets} </p>
                <b><em>Hyponym</em></b> : ${iponimi} </br>
                <p>${iponimiTargets} </p>
                <b><em>PartMeronym</em></b> : ${meronimi} </br>
                <p>${meronimiTargets} </p>
                <b><em>PartHolonym</em></b> : ${olonimi} </br>
                <p>${olonimiTargets} </p>
                <b><em>Synonym (outgoing)</em></b> : ${sinoUscenti} </br>
                <p>${sinoUscentiTargets} </p>
                <b><em>Synonym (incoming)</em></b> : ${sinoEntranti} </br>
                <p>${sinoEntrantiTargets} </p></br>

                <p style="color:#980000"><b>Inferred semantic relations </b> :</p>
                <b><em>Hypernym</em></b> : ${iperonimiInf} </br>
                <p>${iperonimiTargetsInf} </p>
                <b><em>Hyponym</em></b> : ${iponimiInf} </br>
                <p>${iponimiTargetsInf} </p>
                <b><em>PartMeronym</em></b> : ${meronimiInf} </br>
                <p>${meronimiTargetsInf} </p>
                <b><em>PartHolonym</em></b> : ${olonimiInf} </br>
                <p>${olonimiTargetsInf} </p>
                <b><em>Synonym (outgoing)</em></b> : ${sinoUscentiInf} </br>
                <p>${sinoUscentiTargetsInf} </p>
                <b><em>Synonym (incoming)</em></b> : ${sinoEntrantiInf} </br>
                <p>${sinoEntrantiTargetsInf} </p>
               `;
                }
              }
              else {
                panel.innerHTML = `<div id ="x" style="padding-left: 95%;cursor:pointer"> X </div>
                <p><b>Sense</b> : ${this.currentEle.label} </p><p><b>Id</b> : ${this.currentEle.id} </p>
                <p><b>Definition</b> : ${this.currentEle.definition} </p><p><b>POS</b> : ${this.currentEle.pos} </p>
                <p><b>IRI</b> : ${this.currentEle.iri} </p>`;
              }
              document.getElementById('x').addEventListener("click", that.chiudiPannelloInfo);
              panel.style.display = 'block';
              sessionStorage.setItem('panelOpened', 'true')
            });
          } else {
            panel.style.display = 'none';
            sessionStorage.setItem('panelOpened', 'false');
            this.currentEle = null; //resetto il valore
          }
        }, 500);
      }
      else {
        clearTimeout(that.timer);
        that.clicks = 0;
      }
    });
    // chiudo panel se clicco su background
    this.cy.on('click', function (evt) {
      const node = evt.target;
      const panel = document.getElementById('panel');
      if (node === this) {
        if (panel.style.display === 'block') {
          panel.style.display = 'none';
          sessionStorage.setItem('panelOpened', 'false')
        }
      }
    });

    //  recupero info edge al clic sull'edge di interesse
    this.cy.on('tap', 'edge.edge,edge.iponimi,edge.meronimi,edge.sinonimi,edge.percorsoSelected,edge.inferredPercorsoSelected', function (evt) {
      that.clicks++;
      // se clic è singolo apro il panel box
      if (that.clicks === 1) {
        that.timer = setTimeout(function () {
          that.clicks = 0;
          const panel = document.getElementById('panel');
          const node = evt.target;
          // fix quando è checkato il radio button tutte relazioni
          if (this.currentEle !== node.data()) {
            if (node.data().relationType === 'hyponym') {
              that.relationType = 'hyponym'
            }
            if (node.data().relationType === 'partMeronym') {
              that.relationType = 'partMeronym'
            }
            if (node.data().relationType === 'synonym') {
              that.relationType = 'synonym'
            }
            //se ho cliccato sullo stesso elemento di prima per prendere solo id node.data().id
            // richiesta http per recuperare info edge
            that.dataStorageService.fetchInfoEdge(node.data().source, that.relationType, node.data().target).subscribe(infoEdge => {
              this.currentEle = infoEdge;
              // node.flashClass("highlight", 2000);
              // se arco esiste, è diverso da null
              if (infoEdge !== null) {
                panel.innerHTML = `<div id ="x" style="padding-left: 95%;cursor:pointer"> X </div><p><b>ID</b> : ${this.currentEle.id} </p><p><b>SOURCE</b> : ${this.currentEle.source} </p>
                <p><b>TARGET</b> : ${this.currentEle.target} </p><p><b>RELATION TYPE</b> : ${this.currentEle.relationType} </p>
                <p><b>LABEL SOURCE</b> : ${this.currentEle.labelSource} </p><p><b>LABEL TARGET</b> : ${this.currentEle.labelTarget} </p>
                <p><b>INFERRED</b> : ${this.currentEle.inferred} </p>`; //stringhe con variabili all'interno, quello inserito tra $ e par graffa deve essere variabile o espressione ecc.
                panel.style.display = 'block';
                document.getElementById('x').addEventListener("click", that.chiudiPannelloInfo);
              } else {
                // la relazione non esiste
                panel.innerHTML = `<div id ="x" style="padding-left: 95%;cursor:pointer"> X </div>
                <p style="background-color:#f7f5cf;
                padding:10px;
                border: 1px solid #e2dec5;
                border-radius: 5px;"><b> ATTENTION: EDGE DOESN'T EXIST</b></p>`;
                panel.style.display = 'block';
                document.getElementById('x').addEventListener("click", that.chiudiPannelloInfo);
              }
            });
          } else {
            panel.style.display = 'none';
            this.currentEle = null; //resetto il valore
          }
        }, 500);
      }
      else {
        clearTimeout(that.timer);
        that.clicks = 0;
      }
    });
  }

  fetchSenses() {
    this.sub1 = this.dataStorageService.fetchLexicalSense(this.searchText, this.searchMode, this.type,
      this.field, this.pos, this.formType, this.author, this.lang, this.status, this.offset, this.limit).pipe(take(1)).subscribe(lexicalEntry => {
        this.sensi = lexicalEntry.list.filter(t =>
          t.senseInstanceName !== '' && t.definition !== ''
        );
        this.limit += 99;
        this.totalCount = lexicalEntry.totalHits;

        this.sensi = this.sensi.concat(this.sensi);
      });
  }

  public trackByIndex(index: number, value: any) {
    return index;
  }

  cliccato(trat) {
    const that = this;
    // iponimia
    sessionStorage.removeItem("statoNodiIpo");
    sessionStorage.removeItem('statoEdgeIpo');
    this.istanzaHeaderC.relazioneIponimiaDistanza.get('iperonimo').setValue(0);
    this.istanzaHeaderC.relazioneIponimiaDistanza.get('iponimo').setValue(0);
    // meronimia
    sessionStorage.removeItem("statoNodiMero");
    sessionStorage.removeItem('statoEdgeMero');
    this.istanzaHeaderC.relazioneMeronimiaDistanza.get('meronimo').setValue(0);
    this.istanzaHeaderC.relazioneMeronimiaDistanza.get('olonimo').setValue(0);
    // tutte relazioni
    this.istanzaHeaderC.tutteRelazioni.get('relazioni').setValue(0);
    that.spinner.showSpinner();
    that.resettoFormDistanza();
    sessionStorage.setItem('focusNode', trat.senseInstanceName);
    const panel = document.getElementById('panel');
    panel.style.display = 'none';
    this.cy.elements().remove();
    this.sub2 = this.dataStorageService.fetchInfoNode(sessionStorage.getItem('focusNode')).subscribe(subGraph => {
      if (subGraph) {
        that.spinner.hideSpinner();
      }
      that.cy.add([{
        group: "nodes",
        data: {
          id: subGraph.id,
          label: subGraph.label
        }
      }]);
      var elementoCliccato = this.cy.getElementById(subGraph.id);
      that.cy.batch(function () {
        elementoCliccato
          .style('display', 'element')
          .addClass('label')
          .removeClass("inferred")
          .removeClass("2livello")
          .removeClass("grigio")
          .removeClass('tutteRelazioni')
          ;
      });
      this.nodiSelezionati.pop();
      this.clicked = false;
      // mostro solo nodo cliccato dalla lista laterale
      if (this.cy.elements(':visible')) {
        this.cy.elements().style("display", "none");
        this.cy.getElementById(sessionStorage.getItem('focusNode')).style('display', 'element');
      }
      elementoCliccato.connectedEdges().removeClass("2livello");
      // il nodo selezionato dalla lista prende il colore della relazione scelta
      if (this.relationType === 'hyponym') {
        that.cy.batch(function () {
          elementoCliccato
            .removeClass("meronimia")
            .removeClass("sinonimia")
            .removeClass("meronimiaDBClick")
            .removeClass("sinonimiaDBClick")
            .removeClass('tutteRelazioni')
            .addClass('iponimiaDBClick')
            ;
        });
      } else if (this.relationType === 'partMeronym') {
        that.cy.batch(function () {
          elementoCliccato
            .removeClass("iponimia")
            .removeClass("sinonimia")
            .removeClass("iponimiaDBClick")
            .removeClass("sinonimiaDBClick")
            .removeClass('tutteRelazioni')
            .addClass('meronimiaDBClick')
            ;
        });
      } else if (this.relationType === 'synonym') {
        // chiamo direttametne servizio per aprire i nodi
        this.sinonimia();
      } else {
        that.istanzaHeaderC.relazioneIponimiaDistanza.controls['iperonimo'].disable();
        that.istanzaHeaderC.relazioneIponimiaDistanza.controls['iponimo'].disable();
        that.istanzaHeaderC.relazioneMeronimiaDistanza.controls['meronimo'].disable();
        that.istanzaHeaderC.relazioneMeronimiaDistanza.controls['olonimo'].disable();
        that.cy.batch(function () {
          elementoCliccato
            .removeClass("iponimia")
            .removeClass("meronimia")
            .removeClass("sinonimia")
            .removeClass("iponimiaDBClick")
            .removeClass("meronimiaDBClick")
            .removeClass('sinonimiaDBClick')
            .addClass('tutteRelazioni')
            ;
        });
      }
      if (subGraph.links.length === 0) {
        elementoCliccato.addClass('noLinkset');
      }
      this.nodiSelezionati.push(trat);
      sessionStorage.setItem('viewportNavigazioneSingola', trat.senseInstanceName);
      let singola = this.cy.getElementById(sessionStorage.getItem('viewportNavigazioneSingola'))
      this.cy.center(singola);
      // this.cy.zoom({
      //   level: 1,
      //   position: singola.position()
      // });
      // this.cy.$(singola).position({
      //   x: 400,
      //   y: 200
      // });
      elementoCliccato.flashClass('highlightOpen', 1000);
    });
    if (this.relationType === 'hyponym') {
      // iponimi
      this.dataStorageService.fetchNodeMaxHops('hyponym', sessionStorage.getItem('focusNode'), 'incoming').subscribe(elem => {
        if (elem !== null) {
          let primoEl = elem.map(el => {
            return el.lenght;
          })
          let valoreMaxIpo = primoEl.shift();
          this.istanzaHeaderC.valoreMaxIpo = valoreMaxIpo;
          that.disabIpo = false;
        } else {
          that.disabIpo = true;
          this.istanzaHeaderC.valoreMaxIpo = 0;
          that.istanzaHeaderC.relazioneIponimiaDistanza.controls['iponimo'].disable();
        }
      });
      // iperonimi
      this.dataStorageService.fetchNodeMaxHops('hyponym', sessionStorage.getItem('focusNode'), 'outgoing').subscribe(elem => {
        if (elem !== null) {
          let primoEl = elem.map(el => {
            return el.lenght;
          })
          let valoreMaxIpe = primoEl.shift();
          this.istanzaHeaderC.valoreMaxIpe = valoreMaxIpe;
          that.disabIpe = false;
        } else {
          that.disabIpe = true;
          this.istanzaHeaderC.valoreMaxIpe = 0;
          that.istanzaHeaderC.relazioneIponimiaDistanza.controls['iperonimo'].disable();
        }
      });
    }
    if (this.relationType === 'partMeronym') {
      // meronimi
      this.dataStorageService.fetchNodeMaxHops('partMeronym', sessionStorage.getItem('focusNode'), 'outgoing').subscribe(elem => {
        if (elem !== null) {
          let primoEl = elem.map(el => {
            return el.lenght;
          })
          let valoreMaxOlo = primoEl.shift();
          this.istanzaHeaderC.valoreMaxOlo = valoreMaxOlo;
          that.disabOlo = false;
        } else {
          that.disabOlo = true;
          this.istanzaHeaderC.valoreMaxOlo = 0;
          that.istanzaHeaderC.relazioneMeronimiaDistanza.controls['olonimo'].disable();
        }
      });
      // olonimi lascio holonym perchè holonymTerm mi tira su i meronimi(?)
      this.dataStorageService.fetchNodeMaxHops('partMeronym', sessionStorage.getItem('focusNode'), 'incoming').subscribe(elem => {
        if (elem !== null) {
          let primoEl = elem.map(el => {
            return el.lenght;
          })
          let valoreMaxMero = primoEl.shift();
          this.istanzaHeaderC.valoreMaxMero = valoreMaxMero;
          that.disabMero = false;
        } else {
          that.disabMero = true;
          this.istanzaHeaderC.valoreMaxMero = 0;
          that.istanzaHeaderC.relazioneMeronimiaDistanza.controls['meronimo'].disable();
        }
      });
    }
    if (this.relationType === 'tutteRelazioni') {
      // chiamate multiple per recuperare valore max 
      let iperonimi = this.dataStorageService.fetchNodeMaxHops('hyponym', sessionStorage.getItem('focusNode'), 'outgoing');
      let iponimi = this.dataStorageService.fetchNodeMaxHops('hyponym', sessionStorage.getItem('focusNode'), 'incoming');
      let meronimi = this.dataStorageService.fetchNodeMaxHops('partMeronym', sessionStorage.getItem('focusNode'), 'incoming');
      let olonimi = this.dataStorageService.fetchNodeMaxHops('partMeronym', sessionStorage.getItem('focusNode'), 'outgoing');
      let sinonimiI = this.dataStorageService.fetchNodeMaxHops('synonym', sessionStorage.getItem('focusNode'), 'incoming');
      let sinonimiO = this.dataStorageService.fetchNodeMaxHops('synonym', sessionStorage.getItem('focusNode'), 'outgoing');

      const calcoloValoreMax = [iperonimi, iponimi, meronimi, olonimi, sinonimiI, sinonimiO];
      let multiCallValMax = forkJoin(calcoloValoreMax);
      this.sub1 = multiCallValMax.subscribe(valoreMax => {
        let lenght1 = [];
        let lenght2 = [];
        let lenght3 = [];
        let lenght4 = [];
        let lenght5 = [];
        let lenght6 = [];
        if (valoreMax[0] !== null) {
          lenght1 = valoreMax[0].map(el => { return el.lenght });
        }
        if (valoreMax[1] !== null) {
          lenght2 = valoreMax[1].map(el => { return el.lenght });
        }
        if (valoreMax[2] !== null) {
          lenght3 = valoreMax[2].map(el => { return el.lenght });
        }
        if (valoreMax[3] !== null) {
          lenght4 = valoreMax[3].map(el => { return el.lenght });
        }
        if (valoreMax[4] !== null) {
          lenght5 = valoreMax[4].map(el => { return el.lenght });
        }
        if (valoreMax[5] !== null) {
          lenght6 = valoreMax[5].map(el => { return el.lenght });
        }
        let valMax = Math.max(...lenght1, ...lenght2, ...lenght3, ...lenght4, ...lenght5, ...lenght6)
        this.istanzaHeaderC.valoreMax = valMax;
      });
    }
  }

  // relazione di default all'apertura della pagina è iponimia
  // resetto valore focusnode
  ngAfterContentInit() {
    this.onHandleRelazioni('hyponym');
    window.sessionStorage.removeItem('focusNode');
    sessionStorage.clear();
    this.spinner.hideSpinner();
    sessionStorage.setItem('relIponimia', 'hyponym')
  }

  ngAfterViewInit() {
    // virtual scroll
    this.scroller
      .elementScrolled().pipe(
        map(() => this.scroller.measureScrollOffset('bottom')),
        pairwise(),
        filter(([y1, y2]) => (y2 < y1) && (y2 < 140)),
        throttleTime(200)
      ).subscribe(() => {
        this.ngZone.run(() => {
          this.fetchSenses();
        });
      });
  }

  // metodo che gestisce i radio button delle relazioni
  onHandleRelazioni(e: string) {
    if (e === 'hyponym') {
      this.iponimia();
      this.istanzaLayoutMenu.disabilitaBtnMenu = true;
    } else if (e === 'partMeronym') {
      this.meronimia();
      this.istanzaLayoutMenu.disabilitaBtnMenu = true;
    } else if (e === 'synonym') {
      this.sinonimia();
      this.istanzaLayoutMenu.disabilitaBtnMenu = true;
    } else {
      this.tutteRelazioni();
      this.istanzaLayoutMenu.disabilitaBtnMenu = false;
    }
    this.relationType = e;
    return this.relationType;
  }

  onSelectedRadio(e: string) {
    if (e === 'selectRelazione') {
      this.istanzaHeaderC.disabilitaRel = false;
      this.onHandleRelazioni(this.istanzaHeaderC.selected)
    } else {
      this.istanzaHeaderC.disabilitaRel = true;
    }
  }

  iponimia() {
    this.istanzaHeaderC.isChecked = false;
    const that = this;
    that.showFormIpo = true;
    that.showFormMero = false;
    that.showFormSino = false;
    sessionStorage.getItem('focusNode');
    // disabilito form mero e olo
    console.log('iponimia');

    if (sessionStorage.getItem('focusNode') !== null) {
      // // iponimi
      this.dataStorageService.fetchNodeMaxHops('hyponym', sessionStorage.getItem('focusNode'), 'incoming').subscribe(elem => {
        if (elem !== null) {
          let primoEl = elem.map(el => {
            return el.lenght;
          })
          let valoreMaxIpo = primoEl.shift();
          this.istanzaHeaderC.valoreMaxIpo = valoreMaxIpo;
        } else {
          that.disabIpo = true;
          this.istanzaHeaderC.valoreMaxIpo = 0;
          that.istanzaHeaderC.relazioneIponimiaDistanza.controls['iponimo'].disable();
        }
      });
      // iperonimi
      this.dataStorageService.fetchNodeMaxHops('hyponym', sessionStorage.getItem('focusNode'), 'outgoing').subscribe(elem => {
        if (elem !== null) {
          let primoEl = elem.map(el => {
            return el.lenght;
          })
          let valoreMaxIpe = primoEl.shift();
          this.istanzaHeaderC.valoreMaxIpe = valoreMaxIpe;
        } else {
          that.disabIpe = true;
          this.istanzaHeaderC.valoreMaxIpe = 0;
          that.istanzaHeaderC.relazioneIponimiaDistanza.controls['iperonimo'].disable();
        }
      });
    }
    this.disabMero = true;
    this.disabOlo = true;
    this.relationType = 'hyponym';
    sessionStorage.setItem('relIponimia', this.relationType);
    sessionStorage.removeItem('relMeronimia');
    sessionStorage.removeItem('relSinonimia');
    sessionStorage.removeItem('tutteRel');
    let edgesInferred: boolean[];
    let elemSessionStorage = this.cy.getElementById(sessionStorage.getItem('focusNode'));

    // centro l'elemento focus e resetto lo zoom
    this.cy.center(elemSessionStorage);
    this.cy.zoom({
      level: 1,
      position: elemSessionStorage.position()
    });
    // visualizzo e style nodo focus
    this.cy.batch(function () {
      elemSessionStorage
        .style('display', 'element')
        .removeClass('meronimia')
        .removeClass('meronimiaDBClick')
        .removeClass('sinonimia')
        .removeClass('sinonimiaDBClick')
        .removeClass('tutteRelazioni')
        .addClass('iponimiaDBClick')
        ;
    });
    that.statoNodiIpo = JSON.parse(sessionStorage.getItem("statoNodiIpo"));
    that.statoEdgeIpo = JSON.parse(sessionStorage.getItem("statoEdgeIpo"));
    that.istanzaHeaderC.relazioneMeronimiaDistanza.controls['meronimo'].disable();
    that.istanzaHeaderC.relazioneMeronimiaDistanza.controls['olonimo'].disable();
    this.istanzaHeaderC.tutteRelazioni.controls['relazioni'].disable();
    // se non è stato ancora selezionato un senso, e il form è disabilitato, lo abilito
    if (that.istanzaDistanzaIpo.statoIperonimi === null) {
      this.disabIpe = false;
      that.istanzaHeaderC.relazioneIponimiaDistanza.controls['iperonimo'].enable();
    }
    if (that.istanzaDistanzaIpo.statoIponimi === null) {
      this.disabIpo = false;
      that.istanzaHeaderC.relazioneIponimiaDistanza.controls['iponimo'].enable();
    }
    // se stato IPONIMI non è vuoto, cioè è stata effettuata un azione db clic o livello distanza
    if (that.istanzaDistanzaIpo.statoIponimi !== null) {
      // se il valore max è 0 disabilito form
      if (that.istanzaHeaderC.valoreMaxIpo === 0) {
        this.disabIpo = true;
        that.istanzaHeaderC.relazioneIponimiaDistanza.controls['iponimo'].disable();
      } else {
        this.disabIpo = false;
        that.istanzaHeaderC.relazioneIponimiaDistanza.controls['iponimo'].enable();
      }
    }
    // se stato IPERONIMI non è vuoto, cioè è stata effettuata un azione db clic o livello distanza
    if (that.istanzaDistanzaIpo.statoIperonimi !== null) {
      // se il valore max è 0 disabilito form
      if (that.istanzaHeaderC.valoreMaxIpe === 0) {
        this.disabIpe = true;
        that.istanzaHeaderC.relazioneIponimiaDistanza.controls['iperonimo'].disable();
      } else {
        that.istanzaHeaderC.relazioneIponimiaDistanza.controls['iperonimo'].enable();
        this.disabIpe = false;
      }
    }

    // rimuovo elementi dell'array della relazione di meronimia    
    for (var i = 0; i < that.arrayMeronimia.length; i++) {
      let ele = that.arrayMeronimia[i];
      // se l'elemento dell'array è uguale al nodo cliccato,mostralo. 
      if (ele === sessionStorage.getItem('focusNode')) {
        that.cy.getElementById(ele).style('display', 'element');
        // altrimenti rimuovi gli elementi
      } else {
        that.cy.getElementById(ele).remove();
      }
    }
    // rimuovo elementi dell'array della relazione di sinonimia
    for (var i = 0; i < that.arraySinonimia.length; i++) {
      let ele = that.arraySinonimia[i];
      // se l'elemento dell'array è uguale al nodo cliccato,mostralo. 
      if (ele === sessionStorage.getItem('focusNode')) {
        that.cy.getElementById(ele).style('display', 'element');
        // that.cy.getElementById(ele).connectedEdges().addClass('2livello');
        that.cy.getElementById(ele).connectedEdges().remove();
        // altrimenti rimuovi gli elementi
      } else {
        that.cy.getElementById(ele).remove();
      }
    }

    // rimuovo elementi dell'array tutte relazioni
    for (var i = 0; i < that.arrayTutteRelazioni.length; i++) {
      let ele = that.arrayTutteRelazioni[i];
      // se l'elemento dell'array è uguale al nodo cliccato,mostralo. 
      if (ele === sessionStorage.getItem('focusNode')) {
        that.cy.getElementById(ele).style('display', 'element');
        // that.cy.getElementById(ele).connectedEdges().addClass('2livello');
        that.cy.getElementById(ele).connectedEdges().remove();
        // altrimenti rimuovi gli elementi
      } else {
        that.cy.getElementById(ele).remove();
      }
    }
    that.arrayIponimia = [];
    that.arrayNodi = [];
    that.arrayEdge = [];

    // se è stato selezionata la distanza nel form iperonimia o iponimia
    // chiamo il servizio che recupera i nodi con quella distanza
    if (this.istanzaHeaderC.relazioneIponimiaDistanza.get('iperonimo').value !== 0 ||
      this.istanzaHeaderC.relazioneIponimiaDistanza.get('iponimo').value !== 0) {
      // se è stato selezionata la lenght del form degli iperonimi
      if (this.istanzaHeaderC.relazioneIponimiaDistanza.get('iperonimo').value !== 0
      ) {
        // recupero iperonimi
        let valoreFormIpe = this.istanzaHeaderC.relazioneIponimiaDistanza.get('iperonimo').value
        this.istanzaDistanzaIpo.valoreFormIperonimia(valoreFormIpe);
        this.disabIpe = false;
      }
      // se è stata selezionata la lenght del form degli iponimi
      if (this.istanzaHeaderC.relazioneIponimiaDistanza.get('iponimo').value !== 0) {
        // recupero gli iponimi
        let valoreFormIpo = this.istanzaHeaderC.relazioneIponimiaDistanza.get('iponimo').value
        this.istanzaDistanzaIpo.valoreFormIponimia(valoreFormIpo)
        this.disabIpo = false;
      }
    }
    // se passo in iponimia ed è stato selezionata la distanza di meronimi e/o olonimi
    // resetto tutto e mostro solo focus node
    else if (this.istanzaHeaderC.relazioneMeronimiaDistanza.get('meronimo').value !== 0 ||
      this.istanzaHeaderC.relazioneMeronimiaDistanza.get('olonimo').value !== 0) {
      that.cy.remove(that.cy.elements(':visible'));
      elemSessionStorage.restore();
      that.cy.center(elemSessionStorage);
      that.cy.zoom({
        level: 1.0, // the zoom level
      });
    }
    // }
    // funzione db clic
    this.cy.on('dblclick', 'node.iponimiaDBClick,node.iponimia', function (event) {
      for (var i = 0; i < that.arrayMeronimia.length; i++) {
        let ele = that.arrayMeronimia[i];
        // se l'elemento dell'array è uguale al nodo cliccato,mostralo. 
        if (ele === sessionStorage.getItem('focusNode')) {
          that.cy.getElementById(ele).style('display', 'element');
          // altrimenti rimuovi gli elementi
        } else {
          that.cy.getElementById(ele).remove();
        }
      }

      // rimuovo elementi dell'array della relazione di sinonimia
      for (var i = 0; i < that.arraySinonimia.length; i++) {
        let ele = that.arraySinonimia[i];
        // se l'elemento dell'array è uguale al nodo cliccato,mostralo. 
        if (ele === sessionStorage.getItem('focusNode')) {
          that.cy.getElementById(ele).style('display', 'element');
          // altrimenti rimuovi gli elementi
        } else {
          that.cy.getElementById(ele).remove();
        }
      }

      sessionStorage.setItem(event.target, 'focusNode');
      that.relationType = 'hyponym';
      let nodoDBClick = event.target;
      that.cy.batch(function () {
        nodoDBClick.connectedEdges().connectedNodes()
          .removeClass('2livello')
          .removeClass('meronimia')
          .removeClass('meronimiaDBClick')
          .removeClass('sinonimiaDBClick')
          .removeClass('sinonimia')
          .removeClass('iponimiaDBClick')
          .addClass('iponimia')
          ;
      });

      that.cy.batch(function () {
        nodoDBClick
          .removeClass('iponimia')
          .removeClass('sinonimia')
          .removeClass('sinonimiaDBClick')
          .removeClass('meronimia')
          .removeClass('meronimiaDBClick')
          .addClass('iponimiaDBClick')
          ;
      });
    });
  }

  meronimia() {
    this.istanzaHeaderC.isChecked = false;
    const that = this;
    that.showFormMero = true;
    that.showFormIpo = false;
    that.showFormSino = false;
    console.log('meronimia')
    if (sessionStorage.getItem('focusNode') !== null) {
      // meronimi
      this.dataStorageService.fetchNodeMaxHops('partMeronym', sessionStorage.getItem('focusNode'), 'outgoing').subscribe(elem => {
        if (elem !== null) {
          let primoEl = elem.map(el => {
            return el.lenght;
          })
          let valoreMaxOlo = primoEl.shift();
          this.istanzaHeaderC.valoreMaxOlo = valoreMaxOlo;
        } else {
          this.istanzaHeaderC.valoreMaxOlo = 0;
          that.istanzaHeaderC.relazioneMeronimiaDistanza.controls['olonimo'].disable();
        }
      });
      // olonimi
      this.dataStorageService.fetchNodeMaxHops('partMeronym', sessionStorage.getItem('focusNode'), 'incoming').subscribe(elem => {
        if (elem !== null) {
          let primoEl = elem.map(el => {
            return el.lenght;
          })
          let valoreMaxMero = primoEl.shift();
          this.istanzaHeaderC.valoreMaxMero = valoreMaxMero;
        } else {
          this.istanzaHeaderC.valoreMaxMero = 0;
          that.istanzaHeaderC.relazioneMeronimiaDistanza.controls['meronimo'].disable();
        }
      });
    }
    this.disabIpe = true;
    this.disabIpo = true;
    this.relationType = 'partMeronym';
    sessionStorage.setItem('relMeronimia', this.relationType);
    sessionStorage.removeItem('relIponimia');
    sessionStorage.removeItem('relSinonimia');
    sessionStorage.removeItem('tutteRel');
    let edgesInferred: boolean[];
    sessionStorage.getItem('focusNode');
    let elemSessionStorage = this.cy.getElementById(sessionStorage.getItem('focusNode'));
    // centro l'elemento focus e resetto lo zoom
    this.cy.center(elemSessionStorage);
    this.cy.zoom({
      level: 1,
      position: elemSessionStorage.position()
    });
    // visualizzo e style nodo focus
    this.cy.batch(function () {
      elemSessionStorage
        .style('display', 'element')
        .removeClass('iponimia')
        .removeClass('iponimiaDBClick')
        .removeClass('sinonimia')
        .removeClass('sinonimiaDBClick')
        .removeClass('tutteRelazioni')
        .addClass('meronimiaDBClick')
        ;
    });

    that.statoNodiMero = JSON.parse(sessionStorage.getItem("statoNodiMero"));
    that.statoEdgeMero = JSON.parse(sessionStorage.getItem("statoEdgeMero"));
    that.istanzaHeaderC.relazioneIponimiaDistanza.controls['iperonimo'].disable();
    that.istanzaHeaderC.relazioneIponimiaDistanza.controls['iponimo'].disable();
    that.istanzaHeaderC.tutteRelazioni.controls['relazioni'].disable();
    // se non è stato ancora selezionato un senso, e il form è disabilitato, lo abilito

    if (that.istanzaDistanzaMero.statoMeronimi === null) {
      this.disabMero = false;
      that.istanzaHeaderC.relazioneMeronimiaDistanza.controls['meronimo'].enable();
    }
    if (that.istanzaDistanzaMero.statoOlonimi === null) {
      this.disabOlo = false;
      that.istanzaHeaderC.relazioneMeronimiaDistanza.controls['olonimo'].enable();
    }
    // se stato MERONIMI non è undefined, cioè è stata effettuata un azione db clic o livello distanza
    if (that.istanzaDistanzaMero.statoMeronimi !== null) {
      // se il valore max è 0 disabilito form
      if (that.istanzaHeaderC.valoreMaxMero === 0) {
        this.disabMero = true;
        that.istanzaHeaderC.relazioneMeronimiaDistanza.controls['meronimo'].disable();
      } else {
        this.disabMero = false;
        that.istanzaHeaderC.relazioneMeronimiaDistanza.controls['meronimo'].enable();
      }
    }
    // se stato OLONIMI non è undefined, cioè è stata effettuata un azione db clic o livello distanza
    if (that.istanzaDistanzaMero.statoOlonimi !== null) {
      // se il valore max è 0 disabilito form
      if (that.istanzaHeaderC.valoreMaxOlo === 0) {
        this.disabOlo = true;
        that.istanzaHeaderC.relazioneMeronimiaDistanza.controls['olonimo'].disable();
        console.log('valore 0 olo ' + this.disabOlo)
      } else {
        this.disabOlo = false;
        that.istanzaHeaderC.relazioneMeronimiaDistanza.controls['olonimo'].enable();
      }
    }
    // rimuovo elementi dell'array della relazione di iponimia     
    for (var i = 0; i < that.arrayIponimia.length; i++) {
      let ele = that.arrayIponimia[i];
      // se l'elemento dell'array è uguale al nodo cliccato,mostralo. 
      if (ele === sessionStorage.getItem('focusNode')) {
        that.cy.getElementById(ele).style('display', 'element');
        // altrimenti rimuovi gli elementi
      } else {
        that.cy.getElementById(ele).remove();
      }
    }
    // rimuovo elementi dell'array della relazione di sinonimia
    for (var i = 0; i < that.arraySinonimia.length; i++) {
      let ele = that.arraySinonimia[i];
      // se l'elemento dell'array è uguale al nodo cliccato,mostralo. 
      if (ele === sessionStorage.getItem('focusNode')) {
        that.cy.getElementById(ele).style('display', 'element');
        // that.cy.getElementById(ele).connectedEdges().addClass('2livello');
        that.cy.getElementById(ele).connectedEdges().remove();
        // altrimenti rimuovi gli elementi
      } else {
        that.cy.getElementById(ele).remove();
      }
    }
    // rimuovo elementi dell'array tutte relazioni
    for (var i = 0; i < that.arrayTutteRelazioni.length; i++) {
      let ele = that.arrayTutteRelazioni[i];
      // se l'elemento dell'array è uguale al nodo cliccato,mostralo. 
      if (ele === sessionStorage.getItem('focusNode')) {
        that.cy.getElementById(ele).style('display', 'element');
        that.cy.getElementById(ele).connectedEdges().remove();
        // altrimenti rimuovi gli elementi
      } else {
        that.cy.getElementById(ele).remove();
      }
    }

    that.arrayMeronimia = [];
    that.arrayNodi = [];
    that.arrayEdge = [];

    // se è stato selezionata la distanza nel form meronimia o olonimia
    // chiamo il servizio che recupera i nodi con quella distanza
    if (this.istanzaHeaderC.relazioneMeronimiaDistanza.get('meronimo').value !== 0 ||
      this.istanzaHeaderC.relazioneMeronimiaDistanza.get('olonimo').value !== 0) {
      // se è stata selezionata la lenght del form dei meronimi
      if (this.istanzaHeaderC.relazioneMeronimiaDistanza.get('meronimo').value !== 0) {
        // recupero meronimi
        let valoreFormMero = this.istanzaHeaderC.relazioneMeronimiaDistanza.get('meronimo').value;
        this.istanzaDistanzaMero.valoreFormMeronimia(valoreFormMero);
      }
      // se è stata selezionata la length del form degli olonimi
      if (this.istanzaHeaderC.relazioneMeronimiaDistanza.get('olonimo').value !== 0) {
        // recupero gli olonimi
        let valoreFormOlo = this.istanzaHeaderC.relazioneMeronimiaDistanza.get('olonimo').value;
        this.istanzaDistanzaMero.valoreFormOlonimia(valoreFormOlo);
      }
    }
    // se passo in meronimia ed è stato selezionata la distanza di iponimi e/o iperonimi
    // resetto tutto e mostro solo focus node
    else if (this.istanzaHeaderC.relazioneIponimiaDistanza.get('iperonimo').value !== 0 ||
      this.istanzaHeaderC.relazioneIponimiaDistanza.get('iponimo').value !== 0) {
      that.cy.remove(that.cy.elements(':visible'));
      elemSessionStorage.restore();
      that.cy.center(elemSessionStorage);
      that.cy.zoom({
        level: 1.0, // the zoom level
      });
    }
    //  funzione db clic
    this.cy.on('dblclick', '.meronimiaDBClick,.meronimia', function (event) {
      // rimuovo elementi dell'array della relazione di iponimia     
      for (var i = 0; i < that.arrayIponimia.length; i++) {
        let ele = that.arrayIponimia[i];
        // se l'elemento dell'array è uguale al nodo cliccato,mostralo. 
        if (ele === sessionStorage.getItem('focusNode')) {
          that.cy.getElementById(ele).style('display', 'element');
          // altrimenti rimuovi gli elementi
        } else {
          that.cy.getElementById(ele).remove();
        }
      }

      // rimuovo elementi dell'array della relazione di sinonimia
      for (var i = 0; i < that.arraySinonimia.length; i++) {
        let ele = that.arraySinonimia[i];
        // se l'elemento dell'array è uguale al nodo cliccato,mostralo. 
        if (ele === sessionStorage.getItem('focusNode')) {
          that.cy.getElementById(ele).style('display', 'element');
          that.cy.getElementById(ele).connectedEdges().addClass('2livello');
          // altrimenti rimuovi gli elementi
        } else {
          that.cy.getElementById(ele).remove();
        }
      }
      that.relationType = 'partMeronym';
      let nodoDBClick = event.target;
      that.cy.batch(function () {
        nodoDBClick.connectedEdges().connectedNodes()
          .removeClass('2livello')
          .removeClass('iponimia')
          .removeClass('iponimiaDBClick')
          .removeClass('sinonimiaDBClick')
          .removeClass('sinonimia')
          .removeClass('meronimiaDBClick')
          .addClass('meronimia')
          ;
      });

      that.cy.batch(function () {
        nodoDBClick
          .removeClass('meronimia')
          .removeClass('sinonimia')
          .removeClass('sinonimiaDBClick')
          .removeClass('iponimia')
          .removeClass('iponimiaDBClick')
          .addClass('meronimiaDBClick')
          ;
      });
    });
  }

  sinonimia() {
    const that = this;
    that.showFormMero = false;
    that.showFormIpo = false;
    that.showFormSino = true;
    console.log('sinonimia')
    sessionStorage.getItem('focusNode');
    that.istanzaHeaderC.relazioneIponimiaDistanza.controls['iperonimo'].disable();
    that.istanzaHeaderC.relazioneIponimiaDistanza.controls['iponimo'].disable();
    that.istanzaHeaderC.relazioneMeronimiaDistanza.controls['meronimo'].disable();
    that.istanzaHeaderC.relazioneMeronimiaDistanza.controls['olonimo'].disable();
    that.istanzaHeaderC.tutteRelazioni.controls['relazioni'].disable();
    this.relationType = 'synonym';
    sessionStorage.setItem('relSinonimia', this.relationType);
    sessionStorage.removeItem('relMeronimia');
    sessionStorage.removeItem('relIponimia');
    sessionStorage.removeItem('tutteRel');
    let edgesInferred: boolean[];
    let elemSessionStorage = this.cy.getElementById(sessionStorage.getItem('focusNode'));
    // centro l'elemento focus e resetto lo zoom
    this.cy.center(elemSessionStorage);
    this.cy.zoom({
      level: 1,
      position: elemSessionStorage.position()
    });
    // visualizzo e style nodo focus
    this.cy.batch(function () {
      elemSessionStorage
        .style('display', 'element')
        .removeClass('meronimia')
        .removeClass('meronimiaDBClick')
        .removeClass('iponimia')
        .removeClass('iponimiaDBClick')
        .removeClass('tutteRelazioni')
        .addClass('sinonimiaDBClick')
        ;
    });
    that.statoNodiSino = JSON.parse(sessionStorage.getItem("statoNodiSino"));
    that.statoEdgeSino = JSON.parse(sessionStorage.getItem("statoEdgeSino"));
    // rimuovo elementi dell'array della relazione di iponimia     
    for (var i = 0; i < that.arrayMeronimia.length; i++) {
      let ele = that.arrayMeronimia[i];
      // se l'elemento dell'array è uguale al nodo cliccato,mostralo. 
      if (ele === sessionStorage.getItem('focusNode')) {
        that.cy.getElementById(ele).style('display', 'element');
        // altrimenti rimuovi gli elementi
      } else {
        that.cy.getElementById(ele).remove();
      }
    }
    // rimuovo elementi dell'array della relazione di sinonimia
    for (var i = 0; i < that.arrayIponimia.length; i++) {
      let ele = that.arrayIponimia[i];
      // se l'elemento dell'array è uguale al nodo cliccato,mostralo. 
      if (ele === sessionStorage.getItem('focusNode')) {
        that.cy.getElementById(ele).style('display', 'element');
        // that.cy.getElementById(ele).connectedEdges().addClass('2livello');
        that.cy.getElementById(ele).connectedEdges().remove();
        // altrimenti rimuovi gli elementi
      } else {
        that.cy.getElementById(ele).remove();
      }
    }
    // rimuovo elementi dell'array tutte relazioni
    for (var i = 0; i < that.arrayTutteRelazioni.length; i++) {
      let ele = that.arrayTutteRelazioni[i];
      // se l'elemento dell'array è uguale al nodo cliccato,mostralo. 
      if (ele === sessionStorage.getItem('focusNode')) {
        that.cy.getElementById(ele).style('display', 'element');
        that.cy.getElementById(ele).connectedEdges().remove();
        // altrimenti rimuovi gli elementi
      } else {
        that.cy.getElementById(ele).remove();
      }
    }
    that.arraySinonimia = [];
    that.arrayNodi = [];
    that.arrayEdge = [];
    // chiamo servizio di recupero nodi collegati a nodo focus
    let serverData1 = that.dataStorageService.fetchSubGraph(sessionStorage.getItem('focusNode'), that.relationType, 1, "incoming")
    let serverData2 = that.dataStorageService.fetchSubGraph(sessionStorage.getItem('focusNode'), that.relationType, 1, "outgoing")
    const arr = [serverData1, serverData2]
    let multiCall = forkJoin(arr)
    that.sub1 = multiCall.subscribe(subGraph => {
      if (subGraph) {
        that.spinner.hideSpinner();
      }
      subGraph.map(subGraph => {
        let nodi = subGraph.nodes;
        let edges = subGraph.edges;
        edgesInferred = subGraph.edges.map(ele => {
          return ele.data.inferred
        });
        for (var i = 0; i < nodi.length; i++) {
          // aggiungo nodi
          that.cy.add([{
            group: "nodes",
            data: {
              id: subGraph.nodes[i].data.id,
              label: subGraph.nodes[i].data.label
            }
          }]);
          // aggiungo nodi ad array nodi
          that.arraySinonimia.length = that.arraySinonimia.push(subGraph.nodes[i].data.id);
          sessionStorage.setItem("statoNodiSino", JSON.stringify(that.arraySinonimia.length));
          that.arrayNodi.length = that.arrayNodi.push(subGraph.nodes[i].data.id);
          that.cy.getElementById(subGraph.nodes[i].data.id).style('display', 'element');

          let nodiSino = this.cy.getElementById(subGraph.nodes[i].data.id);
          that.cy.batch(function () {
            nodiSino
              .style('display', 'element')
              .addClass('label')
              .addClass('sinonimia')
              ;
          });
        }
        for (var i = 0; i < edges.length; i++) {
          // aggiungo edge
          that.cy.add([{
            group: "edges",
            data: {
              id: subGraph.edges[i].data.id,
              source: subGraph.edges[i].data.source,
              target: subGraph.edges[i].data.target,
              label: subGraph.edges[i].data.relationType
            }
          }]);
          if (edgesInferred[i] === true) {
            that.cy.getElementById(subGraph.edges[i].data.id).addClass("inferred");
          } else {
            that.cy.batch(function () {
              that.cy.getElementById(subGraph.edges[i].data.id)
                .removeClass('2livello')
                .removeClass('inferred')
                .addClass('edges')
                ;
            });
          }
          that.arrayEdge.length = that.arrayEdge.push(that.cy.getElementById(subGraph.edges[i].data.id));
          that.cy.getElementById(subGraph.edges[i].data.id).style('display', 'element');
        }
        // salvo l'elemento focus nella variabile
        let elemSessionStorage = this.cy.getElementById(sessionStorage.getItem('focusNode'));
        // visualizzo nodo focus
        this.cy.center(elemSessionStorage);
        this.cy.zoom({
          level: 1.0, // the zoom level
        });

        elemSessionStorage.connectedEdges().addClass('edges');
        //posizioni pre db clic
        that.layoutSinonimi = elemSessionStorage.connectedEdges().connectedNodes().layout({
          name: 'circle',
          padding: 200,
          avoidOverlap: true,
          radius: 10,
          startAngle: 3 / 2 * Math.PI,
          sweep: undefined,
          clockwise: true,
        });
        that.layoutSinonimi.run();
        // controllo se il grafo è fuori dal viewport faccio fit
        if (that.isGraphOutOfView() === true) {
          that.cy.fit();
        }
      });
    });
    // }
    // }
    // funzione db clic
    this.cy.on('dblclick', '.sinonimiaDBClick,node.sinonimia', function (event) {
      // rimuovo elementi dell'array della relazione di iponimia
      for (var i = 0; i < that.arrayIponimia.length; i++) {
        let ele = that.arrayIponimia[i];
        // se l'elemento dell'array è uguale al nodo cliccato,mostralo. 
        if (ele === sessionStorage.getItem('focusNode')) {
          that.cy.getElementById(ele).style('display', 'element');
          // altrimenti rimuovi gli elementi
        } else {
          that.cy.getElementById(ele).remove();
        }
      }

      // rimuovo elementi dell'array della relazione di meronimia
      for (var i = 0; i < that.arrayMeronimia.length; i++) {
        let ele = that.arrayMeronimia[i];
        // se l'elemento dell'array è uguale al nodo cliccato,mostralo. 
        if (ele === sessionStorage.getItem('focusNode')) {
          that.cy.getElementById(ele).style('display', 'element');
          // altrimenti rimuovi gli elementi
        } else {
          that.cy.getElementById(ele).remove();
        }
      }

      that.relationType = 'synonym';
      let nodoDBClick = event.target;
      that.cy.batch(function () {
        nodoDBClick.connectedEdges().connectedNodes()
          .removeClass('2livello')
          .removeClass('meronimia')
          .removeClass('meronimiaDBClick')
          .removeClass('iponimiaDBClick')
          .removeClass('iponimia')
          .removeClass('sinonimiaDBClick')
          .addClass('sinonimia')
          ;
      });

      that.cy.batch(function () {
        nodoDBClick
          .removeClass('iponimia')
          .removeClass('sinonimia')
          .removeClass('iponimiaDBClick')
          .removeClass('meronimia')
          .removeClass('meronimiaDBClick')
          .addClass('sinonimiaDBClick')
          ;
      });
    });
  }

  chiudiPannelloInfo() {
    const x = document.getElementById('x');
    const panel = document.getElementById('panel');
    panel.style.display = 'none';
  }

  isGraphOutOfView() {
    const width = this.cy.width();
    const height = this.cy.height();
    const rbb = this.cy.elements().renderedBoundingbox();

    return rbb.x1 < 0 || rbb.y1 < 0 || rbb.x2 > width || rbb.y2 > height;
  }

  // chiamo servizio per visualizzare i nodi con distanza scelta dal form distanza iperonimia
  valoreFormIperonimia($event) {
    this.istanzaDistanzaIpo.valoreFormIperonimia($event);
  }

  // chiamo servizio per visualizzare i nodi con distanza scelta dal form distanza iponimia
  valoreFormIponimia($event) {
    this.istanzaDistanzaIpo.valoreFormIponimia($event);
  }

  // chiamo servizio per visualizzare i nodi con distanza scelta dal form distanza meronimia
  valoreFormMeronimia($event) {
    this.istanzaDistanzaMero.valoreFormMeronimia($event);
  }

  // chiamo servizio per visualizzare i nodi con distanza scelta dal form distanza olonimia
  valoreFormOlonimia($event) {
    this.istanzaDistanzaMero.valoreFormOlonimia($event);
  }

  resettoFormDistanza() {
    // resetto form distanza iperonimia quando clicco per visualizzare un nuovo senso
    if (this.relationType === 'hyponym') {
      this.istanzaHeaderC.relazioneIponimiaDistanza.get('iperonimo').setValue(0);
      this.istanzaHeaderC.relazioneIponimiaDistanza.get('iponimo').setValue(0);
    }
    // resetto form distanza meronimia quando clicco per visualizzare un nuovo senso
    if (this.relationType === 'partMeronym') {
      this.istanzaHeaderC.relazioneMeronimiaDistanza.get('meronimo').setValue(0);
      this.istanzaHeaderC.relazioneMeronimiaDistanza.get('olonimo').setValue(0);
    }
  }

  valoreFormIpoRicevuto($event) {
    this.valoreIpo = $event;
  }
  valoreFormIpeRicevuto($event) {
    this.valoreIpe = $event;
  }
  valoreFormOloRicevuto($event) {
    this.valoreOlo = $event;
  }
  valoreFormMeroRicevuto($event) {
    this.valoreMero = $event;
  }
  // valore da ctx menu a form distanza iperonimia
  formIpeDisable($event) {
    this.disabIpe = $event;
  }
  // valore evento da ctx menu a form distanza iponimia
  formIpoDisable($event) {
    this.disabIpo = $event;
  }
  // valore evento da ctx menu a form distanza meronimia
  formMeroDisable($event) {
    this.disabMero = $event;
  }
  // valore evento da ctx menu a form distanza olonimia
  formOloDisable($event) {
    this.disabOlo = $event;
  }

  valoreTutteRelazioniRicevuto($event) {
    this.valoreFormTutteRel = $event;
  }

  stopDistIpo($event) {
    this.stopIpo = $event;
  }

  stopDistIpe($event) {
    this.stopIpe = $event;
  }

  stopDistMero($event) {
    this.stopMero = $event;
  }

  stopDistOlo($event) {
    this.stopOlo = $event;
  }
  ngOnDestroy() {
    this.sub1.unsubscribe();
    this.sub2.unsubscribe();
    this.sub3.unsubscribe();
  }


  tutteRelazioni() {
    this.statoTutteRelazioni = JSON.parse(sessionStorage.getItem("statoTutteRelazioni"));
    const that = this;
    console.log('tutte relazioni')
    if (sessionStorage.getItem('focusNode') !== null) {
      // chiamate multiple per recuperare valore max 
      let iperonimi = this.dataStorageService.fetchNodeMaxHops('hyponym', sessionStorage.getItem('focusNode'), 'outgoing');
      let iponimi = this.dataStorageService.fetchNodeMaxHops('hyponym', sessionStorage.getItem('focusNode'), 'incoming');
      let meronimi = this.dataStorageService.fetchNodeMaxHops('partMeronym', sessionStorage.getItem('focusNode'), 'incoming');
      let olonimi = this.dataStorageService.fetchNodeMaxHops('partMeronym', sessionStorage.getItem('focusNode'), 'outgoing');
      let sinonimiI = this.dataStorageService.fetchNodeMaxHops('synonym', sessionStorage.getItem('focusNode'), 'incoming');
      let sinonimiO = this.dataStorageService.fetchNodeMaxHops('synonym', sessionStorage.getItem('focusNode'), 'outgoing');
      const calcoloValoreMax = [iperonimi, iponimi, meronimi, olonimi, sinonimiI, sinonimiO];
      let multiCallValMax = forkJoin(calcoloValoreMax);
      this.sub1 = multiCallValMax.subscribe(valoreMax => {
        let lenght1 = [];
        let lenght2 = [];
        let lenght3 = [];
        let lenght4 = [];
        let lenght5 = [];
        let lenght6 = [];
        if (valoreMax[0] !== null) {
          lenght1 = valoreMax[0].map(el => { return el.lenght });
        }
        if (valoreMax[1] !== null) {
          lenght2 = valoreMax[1].map(el => { return el.lenght });
        }
        if (valoreMax[2] !== null) {
          lenght3 = valoreMax[2].map(el => { return el.lenght });
        }
        if (valoreMax[3] !== null) {
          lenght4 = valoreMax[3].map(el => { return el.lenght });
        }
        if (valoreMax[4] !== null) {
          lenght5 = valoreMax[4].map(el => { return el.lenght });
        }
        if (valoreMax[5] !== null) {
          lenght6 = valoreMax[5].map(el => { return el.lenght });
        }
        let valMax = Math.max(...lenght1, ...lenght2, ...lenght3, ...lenght4, ...lenght5, ...lenght6)
        this.istanzaHeaderC.valoreMax = valMax;
      });
    }
    let elemSessionStorage = this.cy.getElementById(sessionStorage.getItem('focusNode'));
    // rimuovo elementi dell'array della relazione di iponimia     
    for (var i = 0; i < that.arrayIponimia.length; i++) {
      let ele = that.arrayIponimia[i];
      // se l'elemento dell'array è uguale al nodo cliccato,mostralo. 
      if (ele === sessionStorage.getItem('focusNode')) {
        that.cy.getElementById(ele).style('display', 'element');
        // altrimenti rimuovi gli elementi
      } else {
        that.cy.getElementById(ele).remove();
      }
    }
    // rimuovo elementi dell'array della relazione di iponimia     
    for (var i = 0; i < that.arrayMeronimia.length; i++) {
      let ele = that.arrayMeronimia[i];
      // se l'elemento dell'array è uguale al nodo cliccato,mostralo. 
      if (ele === sessionStorage.getItem('focusNode')) {
        that.cy.getElementById(ele).style('display', 'element');
        // altrimenti rimuovi gli elementi
      } else {
        that.cy.getElementById(ele).remove();
      }
    }
    // rimuovo elementi dell'array della relazione di sinonimia
    for (var i = 0; i < that.arraySinonimia.length; i++) {
      let ele = that.arraySinonimia[i];
      // se l'elemento dell'array è uguale al nodo cliccato,mostralo. 
      if (ele === sessionStorage.getItem('focusNode')) {
        that.cy.getElementById(ele).style('display', 'element');
        // that.cy.getElementById(ele).connectedEdges().addClass('2livello');
        that.cy.getElementById(ele).connectedEdges().remove();
        // altrimenti rimuovi gli elementi
      } else {
        that.cy.getElementById(ele).remove();
      }
    }
    // disabilito i livelli di distanza delle altre relazioni (iponimia e meronimia)
    this.istanzaHeaderC.relazioneIponimiaDistanza.controls['iponimo'].disable();
    this.istanzaHeaderC.relazioneIponimiaDistanza.controls['iperonimo'].disable();
    this.istanzaHeaderC.relazioneMeronimiaDistanza.controls['olonimo'].disable();
    this.istanzaHeaderC.relazioneMeronimiaDistanza.controls['meronimo'].disable();
    this.istanzaHeaderC.tutteRelazioni.controls['relazioni'].enable();

    that.cy.batch(function () {
      elemSessionStorage
        .removeClass('iponimiaDBClick')
        .removeClass('iponimia')
        .removeClass('meronimia')
        .removeClass('meronimiaDBClick')
        .removeClass('sinonimiaDBClick')
        .removeClass('sinonimia')
        .addClass('tutteRelazioni')
        ;
    });

    this.visualizzaRelazioni = this.istanzaHeaderC.tutteRelazioni.get('relazioni').value;
    sessionStorage.setItem('tutteRel', this.visualizzaRelazioni)
    sessionStorage.removeItem('relMeronimia');
    sessionStorage.removeItem('relSinonimia');
    sessionStorage.removeItem('relIponimia');
    // se sono stati selezionati nodi da input distanza
    // IPONIMIA
    let iponimia1 = this.dataStorageService.fetchSubGraph(sessionStorage.getItem('focusNode'), 'hyponym', this.visualizzaRelazioni, "incoming");
    let iponimia2 = this.dataStorageService.fetchSubGraph(sessionStorage.getItem('focusNode'), 'hyponym', this.visualizzaRelazioni, "outgoing");
    // MERONIMIA
    let meronimia1 = this.dataStorageService.fetchSubGraph(sessionStorage.getItem('focusNode'), 'partMeronym', this.visualizzaRelazioni, "incoming");
    let meronimia2 = this.dataStorageService.fetchSubGraph(sessionStorage.getItem('focusNode'), 'partMeronym', this.visualizzaRelazioni, "outgoing");
    // SINONIMIA
    let sinonimia1 = this.dataStorageService.fetchSubGraph(sessionStorage.getItem('focusNode'), 'synonym', this.visualizzaRelazioni, "incoming")
    let sinonimia2 = this.dataStorageService.fetchSubGraph(sessionStorage.getItem('focusNode'), 'synonym', this.visualizzaRelazioni, "outgoing")
    const arr = [iponimia1, iponimia2, meronimia1, meronimia2, sinonimia1, sinonimia2];
    let multiCall = forkJoin(arr);
    if (this.statoTutteRelazioni !== null) {
      this.sub1 = multiCall.subscribe(subGraph => {
        subGraph.map(relazioni => {
          let nodi = relazioni.nodes;
          let edges = relazioni.edges;
          let elemSessionStorage = this.cy.getElementById(sessionStorage.getItem('focusNode'));
          let nodiRecuperati = subGraph[0].nodes.concat(subGraph[1].nodes, subGraph[2].nodes, subGraph[3].nodes, subGraph[4].nodes,
            subGraph[5].nodes);
          for (var i = 0; i < nodi.length; i++) {
            // aggiungo nodi
            this.cy.add([{
              group: "nodes",
              data: {
                id: relazioni.nodes[i].data.id,
                label: relazioni.nodes[i].data.label
              }
            }]);
            this.cy.getElementById(relazioni.nodes[i].data.id).style('display', 'element');
            this.cy.getElementById(relazioni.nodes[i].data.id).addClass('label');
            elemSessionStorage.addClass('tutteRelazioni');
            this.arrayTutteRelazioni.length = this.arrayTutteRelazioni.push(relazioni.nodes[i].data.id)
            // stato relazione di iponimia unico (sia iponimi che iperonimi)
            sessionStorage.setItem("statoTutteRelazioni", JSON.stringify(this.arrayTutteRelazioni.length));
          }
          for (var i = 0; i < edges.length; i++) {
            // aggiungo edge
            this.cy.add([{
              group: "edges",
              data: {
                id: relazioni.edges[i].data.id,
                source: relazioni.edges[i].data.source,
                target: relazioni.edges[i].data.target,
                relationType: relazioni.edges[i].data.relationType,
                label: relazioni.edges[i].data.relationType
              }
            }]);
            this.cy.getElementById(relazioni.edges[i].data.id).style('display', 'element');
            if (edges[i].data.relationType === 'hyponym') {
              let iponimia = this.cy.getElementById(edges[i].data.id);
              iponimia.addClass('iponimi');
            } else if (edges[i].data.relationType === 'partMeronym') {
              let meronimia = this.cy.getElementById(edges[i].data.id);
              meronimia.addClass('meronimi');
            } else {
              let sinonimia = this.cy.getElementById(edges[i].data.id);
              sinonimia.addClass('sinonimi');
            }
          }
          // iponimi e iperonimi
          let iponimi = subGraph[0].nodes;
          let iperonimi = subGraph[1].nodes;
          for (var i = 0; i < iponimi.length; i++) {
            // shade più chiara
            if (this.cy.getElementById(iponimi[i].data.id) !== elemSessionStorage) {
              this.cy.getElementById(iponimi[i].data.id).addClass('tutteRel_Iponimi');
            }

          }
          for (var i = 0; i < iperonimi.length; i++) {
            // shade più scura
            if (this.cy.getElementById(iperonimi[i].data.id) !== elemSessionStorage) {
              this.cy.getElementById(iperonimi[i].data.id).addClass('tutteRel_Iperonimi');
            }
          }
          // meronimi e olonimi
          let meronimi = subGraph[2].nodes;
          let olonimi = subGraph[3].nodes;
          for (var i = 0; i < meronimi.length; i++) {
            // shade più chiara
            if (this.cy.getElementById(meronimi[i].data.id) !== elemSessionStorage) {
              this.cy.getElementById(meronimi[i].data.id).addClass('tutteRel_Meronimi');
            }
          }
          for (var i = 0; i < olonimi.length; i++) {
            // shade più scura
            if (this.cy.getElementById(olonimi[i].data.id) !== elemSessionStorage) {
              this.cy.getElementById(olonimi[i].data.id).addClass('tutteRel_Olonimi');
            }
          }
          // sinonimi
          let sinoEntranti = subGraph[4].nodes;
          let sinoUscenti = subGraph[4].nodes;
          for (var i = 0; i < sinoEntranti.length; i++) {
            if (this.cy.getElementById(sinoEntranti[i].data.id) !== elemSessionStorage) {
              this.cy.getElementById(sinoEntranti[i].data.id).addClass('tutteRel_Sinonimi');
            }
          }
          for (var i = 0; i < sinoUscenti.length; i++) {
            if (this.cy.getElementById(sinoUscenti[i].data.id) !== elemSessionStorage) {
              this.cy.getElementById(sinoUscenti[i].data.id).addClass('tutteRel_Sinonimi');
            }
          }
          // se è stato scelto il layout cise dal menu 
          if (this.layoutCise === true || this.istanzaHeaderC.layoutCiseScelto === true) {
            if (this.visualizzaRelazioni > 0) {
              this.istanzaLayoutMenu.ciseLayout();
              var elementiVisibili = this.cy.elements(':visible');
              this.cy.center(elementiVisibili);
            } else {
              this.cy.center(elemSessionStorage);
              this.cy.zoom({
                level: 1,
                position: elemSessionStorage.position()
              });
            }
          }
          // se è stato scelto il layout cose bilkent dal menu  
          if (this.layoutCoseBilkent === true) {
            if (this.visualizzaRelazioni > 0) {
              this.istanzaLayoutMenu.coseBilkentLayout();
              var elementiVisibili = this.cy.elements(':visible');
              this.cy.center(elementiVisibili);
            } else {
              this.cy.center(elemSessionStorage);
              this.cy.zoom({
                level: 1,
                position: elemSessionStorage.position()
              });
            }
          }
          // se è stato scelto il layout cola 
          if (this.layoutCola === true || this.istanzaHeaderC.layoutColaScelto === true) {
            if (this.visualizzaRelazioni > 0) {
              this.istanzaLayoutMenu.colaLayout();
              var elementiVisibili = this.cy.elements(':visible');
              this.cy.center(elementiVisibili);
            } else {
              this.cy.center(elemSessionStorage);
              this.cy.zoom({
                level: 1,
                position: elemSessionStorage.position()
              });
            }
          }
          // se è stato scelto il layout euler
          if (this.layoutEuler === true || this.istanzaHeaderC.layoutEulerScelto === true) {
            if (this.visualizzaRelazioni > 0) {
              this.istanzaLayoutMenu.eulerLayout();
              var elementiVisibili = this.cy.elements(':visible');
              this.cy.center(elementiVisibili);
            } else {
              this.cy.center(elemSessionStorage);
              this.cy.zoom({
                level: 1,
                position: elemSessionStorage.position()
              });
            }
          }
          // se è stato scelto il layout cose 
          if (this.layoutCose === true || this.istanzaHeaderC.layoutCoseScelto === true) {
            if (this.visualizzaRelazioni > 0) {
              this.istanzaLayoutMenu.coseLayout();
              var elementiVisibili = this.cy.elements(':visible');
              this.cy.center(elementiVisibili);
            } else {
              this.cy.center(elemSessionStorage);
              this.cy.zoom({
                level: 1,
                position: elemSessionStorage.position()
              });
            }
          }
        });
        //aggiungo/rimuovo classe label agli edge 
        if (this.isChecked === true) {
          this.cy.edges().filter(':visible').addClass('label');
          this.cy.edges().filter(':visible').style("edge-text-rotation", "autorotate");
        } else {
          this.cy.edges().filter(':visible').removeClass('label');
        }
      });
    }
  }

  layoutCiseScelto($event) {
    this.layoutCise = $event;
  }

  layoutCoseBilkentScelto($event) {
    this.layoutCoseBilkent = $event;
  }
  layoutColaScelto($event) {
    this.layoutCola = $event;
  }
  layoutEulerScelto($event) {
    this.layoutEuler = $event;
  }

  layoutCoseScelto($event) {
    this.layoutCose = $event;
  }

  checkboxIpo($event) {
    this.checkboxIpoRicev = $event;
  }

  checkboxMero($event) {
    this.checkboxMeroRicev = $event;
  }
  checkboxSino($event) {
    this.checkboxSinoRicev = $event;
  }

  labelChecked($event) {
    this.isChecked = $event;
  }

  // visualizzo componente filtro multiplo
  visualizzaNavigazione(navigazioneScelta) {
    let viewportSing = sessionStorage.getItem('viewportNavigazioneSingola')
    const apriBox = document.getElementById('boxCreaElemento');
    const panel = document.getElementById('panel');
    const dialogModifyNode = document.getElementById('dialogModifyNode');
    if (navigazioneScelta === "navigazioneMultipla") {
      if(sessionStorage.getItem('showDialogModifyNode')==='true'){
        dialogModifyNode.style.display = 'block';
      } else {
        dialogModifyNode.style.display = 'none';
      }
      sessionStorage.setItem('navigazioneMultipla', 'true');
      // chiudo pannello panel con informazioni su nodo / edge cliccato
      panel.style.display = 'none';
      // controllo slider recupero inferenze
      if (sessionStorage.getItem('disableSliderInf') === 'false') {
        this.disabilitaSliderBtn = false;
        // slider inferenze
        if (sessionStorage.getItem('sliderChecked') === 'true') {
          this.isCheck = true;
        } else {
          this.isCheck = false;
        }
        // slider concetti
        if (sessionStorage.getItem('sliderConceptIncludesIsCheck') === 'true') {
          this.conceptIncludesIsCheck = true;
        } else {
          this.conceptIncludesIsCheck = false;
        }
      } else {
        this.disabilitaSliderBtn = true;
      }
      if (sessionStorage.getItem('boxOpened') === 'true') {
        apriBox.style.display = 'inline';
        this.isOpen = true;
      } else {
        this.isOpen = false;
      }
      sessionStorage.getItem('statoChecked');
      this.showComponent = true;
      this.showComponentSingle = false;
      document.getElementById('navigazione').style.display = 'none'
      this.viewSingola = this.cy.elements(':visible');
      if (viewportSing !== null) {
        this.viewSingola = this.cy.remove(viewportSing);
      }
      if (this.viewMultiplaRicevuta !== undefined) {
        this.viewMultipla.restore();
        this.cy.center();
        this.eventsSubject.next('true');
      }
    } else {
      sessionStorage.setItem('navigazioneMultipla', 'false')
      this.showComponent = false;
      this.showComponentSingle = true;
      document.getElementById('navigazione').style.display = 'block'
      apriBox.style.display = 'none';
      dialogModifyNode.style.display = 'none';
      if (this.viewMultiplaRicevuta !== undefined) {
        this.viewMultipla = this.cy.remove(this.viewMultiplaRicevuta);
      }
      if (viewportSing !== null) {
        this.viewSingola.restore();
      }

      if (sessionStorage.getItem('panelOpened') === 'true') {
        panel.style.display = 'block';
      } else {
        panel.style.display = 'none'
      }
      // restore relazione scelta
      if (sessionStorage.getItem('relIponimia') !== null) {
        this.iponimia();
      }
      if (sessionStorage.getItem('relMeronimia') !== null) {
        this.meronimia();
      }
      if (sessionStorage.getItem('relSinonimia') !== null) {
        this.sinonimia();
      }
      if (sessionStorage.getItem('tutteRel') !== null) {
        this.tutteRelazioni();
      }
    }
  }

  viewMultiplaricevuta($event) {
    this.viewMultiplaRicevuta = $event;
  }

  clickedMultiplo($event) {
    this.clickMultiplo = $event;
    this.eventsSubject.next($event);
  }

  creaElemento($event) {
    const apriBox = document.getElementById('boxCreaElemento');
    sessionStorage.setItem('boxOpened', $event);
    if ($event === true) {
      apriBox.style.display = 'inline';
    }
    else {
      apriBox.style.display = 'none';
    }
  }

  headerMultiploIsRefreshed($event) {
    this.pageIsRefresh = $event;
    this.eventsSubjectPageRefresh.next($event);
  }

  btnMinPathClicked($event) {
    this.eventsSubjectBtnMinPathClicked.next($event);
  }

  inferenzeRecuperate($event) {
    this.eventsSubjectInferenzeRecuperate.next($event);
  }

  concettiRecuperati($event) {
    this.eventsSubjectConcettiRecuperati.next($event);
  }

  idNodoRicevuto($event){
    this.idRicevuto = $event;
  }

  labelReceived($event){
    this.labelRicevuto = $event;
  }
  
  definitionRiceived($event){
    this.definitionRicevuto = $event;
  }
}
